import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { jsPDF } from 'jspdf';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import './App.css';

const API = window.location.hostname === 'localhost' ? 'http://localhost:8080/api' : '/api';

const getIdEstabelecimento = () => {
  const u = localStorage.getItem('usuario');
  return u ? JSON.parse(u).idEstabelecimento : null;
};

function Header() {
  return (
    <div className="header">
      <div className="header-center">
        <h1 className="header-titulo">FLUORITA ESPAÇO DE BELEZA</h1>
      </div>
    </div>
  );
}

function Sidebar({ aberto, onNavigate, onFechar, onLogout }) {
  return (
    <>
      {aberto && <div className="sidebar-overlay" onClick={onFechar} />}
      <nav className={`sidebar ${aberto ? 'aberto' : ''}`}>
        <button className="sidebar-fechar" onClick={onFechar}>✕</button>
        <ul>
          <li onClick={() => { onNavigate('home'); onFechar(); }}>📅 Agendamentos</li>
          <li onClick={() => { onNavigate('semana'); onFechar(); }}>📋 Agenda da Semana</li>
          <li onClick={() => { onNavigate('tabela-precos'); onFechar(); }}>💲 Tabela de Preços</li>
          <li onClick={() => { onNavigate('anotacoes'); onFechar(); }}>🗒️ Anotações</li>
          <li onClick={() => { onNavigate('bloco-notas'); onFechar(); }}>📝 Bloco de Notas</li>
          <li onClick={() => { onNavigate('relatorio'); onFechar(); }}>📊 Relatório Financeiro</li>
          <li onClick={() => { onNavigate('saida'); onFechar(); }}>💸 Cadastrar Saída</li>
          <li onClick={() => { onNavigate('clientes'); onFechar(); }}>👤 Clientes</li>
          <li onClick={() => { onNavigate('historico'); onFechar(); }}>🕓 Histórico</li>
          <li className="sidebar-logout" onClick={() => { onLogout(); onFechar(); }}>🚪 Sair</li>
        </ul>
        <img src="/logo.png" alt="" className="sidebar-watermark" />
      </nav>
    </>
  );
}

const FORMAS_PAGAMENTO = [
  { value: 'DINHEIRO', label: 'Dinheiro' },
  { value: 'PIX', label: 'PIX' },
  { value: 'CARTAO_CREDITO', label: 'Cartão de Crédito' },
  { value: 'CARTAO_DEBITO', label: 'Cartão de Débito' },
  { value: 'FIADO', label: 'Fiado' },
];

const hojeDate = () => { const d = new Date(); return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0'); };
const horaAtual = () => new Date().toTimeString().slice(0, 5);
const mascaraTelefone = (v) => {
  v = v.replace(/\D/g, '').slice(0, 11);
  if (v.length > 6) return '(' + v.slice(0,2) + ') ' + v.slice(2,7) + '-' + v.slice(7);
  if (v.length > 2) return '(' + v.slice(0,2) + ') ' + v.slice(2);
  if (v.length > 0) return '(' + v;
  return v;
};

const initialForm = {
  nomeCliente: '',
  telefone: '',
  dataNascimento: '',
  data: hojeDate(),
  hora: horaAtual(),
  servico: '',
  valor: '',
  formaPagamento: 'PIX',
  observacao: '',
};

const formatarData = dt => dt ? new Date(dt).toLocaleString('pt-BR', { day:'2-digit', month:'2-digit', year:'2-digit', hour:'2-digit', minute:'2-digit' }) : '';
const formatarDataCurta = dt => dt ? new Date(dt + 'T00:00:00').toLocaleDateString('pt-BR', { day:'2-digit', month:'2-digit', year:'2-digit' }) : '';
const formatarDataTabela = dt => dt ? new Date(dt).toLocaleDateString('pt-BR', { day:'2-digit', month:'2-digit', year:'2-digit' }) : '';
const formatarValor = v => parseFloat(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const labelPagamento = v => FORMAS_PAGAMENTO.find(f => f.value === v)?.label || v;
const labelPagamentos = a => {
  if (a.pagamentos && a.pagamentos.length > 0) {
    return a.pagamentos.map(p => labelPagamento(p.formaPagamento) + ' ' + formatarValor(p.valor)).join(' + ');
  }
  return labelPagamento(a.formaPagamento);
};

function getInicioFim(filtro) {
  const now = new Date();
  const pad = d => d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
  let inicio, fim;
  if (filtro === 'semana') {
    const day = now.getDay();
    inicio = new Date(now); inicio.setDate(now.getDate() - day); inicio.setHours(0,0,0,0);
    fim = new Date(inicio); fim.setDate(inicio.getDate() + 6);
  } else if (filtro === 'mes') {
    inicio = new Date(now.getFullYear(), now.getMonth(), 1);
    fim = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  } else {
    inicio = new Date(now.getFullYear(), 0, 1);
    fim = new Date(now.getFullYear(), 11, 31);
  }
  return { inicio: pad(inicio) + 'T00:00:00', fim: pad(fim) + 'T23:59:59' };
}

function getInicioFimSemana() {
  const now = new Date(); const day = now.getDay();
  const inicio = new Date(now); inicio.setDate(now.getDate() - day); inicio.setHours(0,0,0,0);
  const fim = new Date(inicio); fim.setDate(inicio.getDate() + 6);
  const pad = d => d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
  return { inicio: pad(inicio) + 'T00:00:00', fim: pad(fim) + 'T23:59:59' };
}

function getInicioFimHoje() {
  const now = new Date();
  const hoje = now.getFullYear() + '-' + String(now.getMonth()+1).padStart(2,'0') + '-' + String(now.getDate()).padStart(2,'0');
  return { inicio: hoje + 'T00:00:00', fim: hoje + 'T23:59:59' };
}

// ==================== TELA 1: HOME ====================
function TelaHome({ onNavigate }) {
  const [agendamentos, setAgendamentos] = useState([]);
  const [pagina, setPagina] = useState(0);
  const [totalPaginas, setTotalPaginas] = useState(0);
  const [form, setForm] = useState(initialForm);
  const [editId, setEditId] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [sugestoes, setSugestoes] = useState([]);
  const [erro, setErro] = useState('');
  const [repetir, setRepetir] = useState(false);
  const [qtdRepetir, setQtdRepetir] = useState('');
  const [pagamentos, setPagamentos] = useState([{ formaPagamento: 'PIX', valor: '' }]);
  const [obsAberto, setObsAberto] = useState(false);

  const carregar = (pg = pagina) => {
    const idEstab = getIdEstabelecimento();
    if (!idEstab) return;
    axios.get(`${API}/agendamentos?idEstab=${idEstab}&page=${pg}&size=30`).then(r => {
      setAgendamentos(r.data.content);
      setTotalPaginas(r.data.totalPages);
    });
    axios.get(`${API}/clientes?idEstab=${idEstab}`).then(r => setClientes(r.data));
  };
  useEffect(() => {
    carregar();
    if (!editId) setPagamentos([{ formaPagamento: 'PIX', valor: '' }]);
    const handleEditarEvento = (e) => {
      const a = e.detail;
      const pags = (a.pagamentos && a.pagamentos.length > 0) ? a.pagamentos.map(p => ({ formaPagamento: p.formaPagamento, valor: p.valor })) : [{ formaPagamento: a.formaPagamento, valor: a.valor }];
      setForm({ nomeCliente: a.nomeCliente, telefone: a.telefone, data: a.dataHora?.slice(0,10)||'', hora: a.dataHora?.slice(11,16)||'', servico: a.servico, valor: a.valor, formaPagamento: a.formaPagamento, observacao: a.observacao||'' });
      setPagamentos(pags);
      setEditId(a.id);
      setObsAberto(!!a.observacao);
    };
    window.addEventListener('editarAgendamento', handleEditarEvento);
    const handleAgendarNoDia = (e) => {
      setForm(prev => ({ ...prev, data: e.detail.data }));
    };
    window.addEventListener('agendarNoDia', handleAgendarNoDia);
    return () => { window.removeEventListener('editarAgendamento', handleEditarEvento); window.removeEventListener('agendarNoDia', handleAgendarNoDia); };
  }, [pagina]);

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === 'telefone') { setForm({ ...form, telefone: mascaraTelefone(value) }); return; }
    setForm({ ...form, [name]: value });
    if (name === 'nomeCliente') {
      setSugestoes(value.length > 0 ? clientes.filter(c => c.nome.toLowerCase().includes(value.toLowerCase())) : []);
    }
    if (name === 'data' || name === 'hora') setErro('');
  };

  const selecionarCliente = cliente => {
    setForm({ ...form, nomeCliente: cliente.nome, telefone: cliente.telefone, dataNascimento: cliente.dataNascimento || '' });
    setSugestoes([]);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const dataHora = `${form.data}T${form.hora}`;
    const pagamentosPayload = pagamentos.filter(p => p.formaPagamento && parseFloat(p.valor) > 0).map(p => ({ formaPagamento: p.formaPagamento, valor: parseFloat(p.valor) }));
    const valorTotal = pagamentosPayload.length > 0 ? pagamentosPayload.reduce((s, p) => s + p.valor, 0) : (parseFloat(form.valor) || 0);
    const payload = { dataHora, nomeCliente: form.nomeCliente, telefone: form.telefone, servico: form.servico, valor: valorTotal, formaPagamento: pagamentosPayload[0]?.formaPagamento || 'PIX', pagamentos: pagamentosPayload, idEstabelecimento: getIdEstabelecimento(), observacao: form.observacao || null, dataNascimentoCliente: form.dataNascimento || null };
    if (editId) {
      await axios.put(`${API}/agendamentos/${editId}`, payload);
    } else {
      await axios.post(`${API}/agendamentos`, payload);
      if (repetir && parseInt(qtdRepetir) > 0) {
        const baseDate = new Date(`${form.data}T${form.hora}`);
        for (let i = 1; i <= parseInt(qtdRepetir); i++) {
          const novaData = new Date(baseDate);
          novaData.setDate(novaData.getDate() + (7 * i));
          const novaDataHora = novaData.getFullYear() + '-' + String(novaData.getMonth()+1).padStart(2,'0') + '-' + String(novaData.getDate()).padStart(2,'0') + 'T' + form.hora;
          await axios.post(`${API}/agendamentos`, { ...payload, dataHora: novaDataHora, valor: 0, repeticao: true });
        }
      }
    }
    setForm({ ...initialForm, data: hojeDate(), hora: horaAtual() });
    setPagamentos([{ formaPagamento: 'PIX', valor: '' }]);
    setEditId(null); setSugestoes([]); setErro(''); setRepetir(false); setQtdRepetir(''); setObsAberto(false); carregar(pagina);
    onNavigate('semana');
  };

  const editar = a => {
    const pags = (a.pagamentos && a.pagamentos.length > 0) ? a.pagamentos.map(p => ({ formaPagamento: p.formaPagamento, valor: p.valor })) : [{ formaPagamento: a.formaPagamento, valor: a.valor }];
    setForm({ nomeCliente: a.nomeCliente, telefone: a.telefone, data: a.dataHora?.slice(0,10)||'', hora: a.dataHora?.slice(11,16)||'', servico: a.servico, valor: a.valor, formaPagamento: a.formaPagamento, observacao: a.observacao||'' });
    setPagamentos(pags);
    setEditId(a.id); setErro(''); setObsAberto(!!a.observacao);
  };

  const deletar = async id => {
    if (window.confirm('Deseja excluir este agendamento?')) {
      await axios.delete(`${API}/agendamentos/${id}`); carregar(pagina);
    }
  };

  const finalizar = async id => {
    await axios.patch(`${API}/agendamentos/${id}/finalizar`); carregar(pagina);
  };

  return (
    <div className="container">
      <Header />

      {erro && <div className="mensagem-erro">{erro}</div>}

      <form onSubmit={handleSubmit} className="form">
        <div className="form-grid">
          <label className="autocomplete-wrapper">
            Nome da Cliente
            <input type="text" name="nomeCliente" value={form.nomeCliente} onChange={handleChange} required autoComplete="off" />
            {sugestoes.length > 0 && (
              <ul className="autocomplete-list">
                {sugestoes.map(c => <li key={c.id} onClick={() => selecionarCliente(c)}>{c.nome} — {c.telefone}</li>)}
              </ul>
            )}
          </label>
          <label>
            Telefone
            <input type="tel" name="telefone" value={form.telefone} onChange={handleChange} required placeholder="(00) 00000-0000" />
          </label>
          <label>
            Data de Nascimento
            <input type="date" name="dataNascimento" value={form.dataNascimento||''} onChange={handleChange} />
          </label>
          <label>
            Data
            <input type="date" name="data" value={form.data} onChange={handleChange} required />
          </label>
          <label>
            Hora
            <input type="time" name="hora" value={form.hora} onChange={handleChange} required />
          </label>
          <label>
            Serviço
            <input type="text" name="servico" value={form.servico} onChange={handleChange} required />
          </label>
          <label>
            Valor Total (R$)
            <input type="number" name="valor" value={form.valor} onChange={handleChange} min="0" step="0.01" placeholder="Preencher depois" />
          </label>
        </div>
        <div className="obs-toggle" onClick={() => setObsAberto(!obsAberto)}>
          {obsAberto ? '▼' : '▶'} <em>Observação</em> {form.observacao && !obsAberto && <span className="obs-preview">({form.observacao.slice(0, 30)}...)</span>}
        </div>
        {obsAberto && (
          <textarea className="obs-campo" name="observacao" value={form.observacao} onChange={handleChange} maxLength={300} placeholder="Observação (até 300 caracteres)" />
        )}
        {parseFloat(form.valor) > 0 && (
          <div className="pagamentos-dinamicos">
            <p className="pagamentos-titulo">Formas de Pagamento:</p>
            {pagamentos.map((pag, idx) => {
              const formasUsadas = pagamentos.filter((_, i) => i !== idx).map(p => p.formaPagamento);
              const formasDisponiveis = FORMAS_PAGAMENTO.filter(f => !formasUsadas.includes(f.value));
              const totalPago = pagamentos.reduce((s, p) => s + (parseFloat(p.valor) || 0), 0);
              const restante = parseFloat(form.valor) - totalPago + (parseFloat(pag.valor) || 0);
              return (
                <div key={idx} className="pagamento-linha">
                  <select value={pag.formaPagamento} onChange={e => { const novo = [...pagamentos]; novo[idx].formaPagamento = e.target.value; setPagamentos(novo); }}>
                    <option value="">Selecione...</option>
                    {formasDisponiveis.map(f => <option key={f.value} value={f.value}>{f.label}</option>)}
                  </select>
                  <input type="number" placeholder={`R$ (restante: ${formatarValor(restante)})`} value={pag.valor} min="0" step="0.01" onChange={e => {
                    const novo = [...pagamentos]; novo[idx].valor = e.target.value; setPagamentos(novo);
                    const novoTotal = novo.reduce((s, p) => s + (parseFloat(p.valor) || 0), 0);
                    const falta = parseFloat(form.valor) - novoTotal;
                    if (falta > 0 && novo.length === idx + 1) { setPagamentos([...novo, { formaPagamento: '', valor: '' }]); }
                    else if (falta <= 0 && novo.length > idx + 1) { setPagamentos(novo.slice(0, idx + 1)); }
                  }} />
                  {idx > 0 && <button type="button" className="btn-remover-pag" onClick={() => setPagamentos(pagamentos.filter((_, i) => i !== idx))}>✕</button>}
                </div>
              );
            })}
            {(() => { const totalPago = pagamentos.reduce((s, p) => s + (parseFloat(p.valor) || 0), 0); const falta = parseFloat(form.valor) - totalPago; return falta > 0 ? <p className="pagamento-falta">Falta: {formatarValor(falta)}</p> : falta === 0 ? <p className="pagamento-ok">✅ Valor completo</p> : <p className="pagamento-excesso">⚠️ Excede em {formatarValor(Math.abs(falta))}</p>; })()}
          </div>
        )}
        <div className="form-actions">
          <button type="submit">{editId ? 'Atualizar' : 'Agendar'}</button>
          {editId && <button type="button" onClick={() => { setForm({ ...initialForm, data: hojeDate(), hora: horaAtual() }); setEditId(null); setErro(''); }}>Cancelar</button>}
          {!editId && (
            <label className="repetir-check">
              <input type="checkbox" checked={repetir} onChange={e => { setRepetir(e.target.checked); if (!e.target.checked) setQtdRepetir(''); }} />
              <em>Repetir agendamento?</em>
              {repetir && (
                <input type="number" className="repetir-input" min="1" max="52" value={qtdRepetir} onChange={e => setQtdRepetir(e.target.value)} placeholder="Quantas semanas?" required />
              )}
            </label>
          )}
        </div>
      </form>

      <table>
        <thead>
          <tr>
            <th>Cliente</th>
            <th>Telefone</th>
            <th>Data</th>
            <th>Hora</th>
            <th>Serviço</th>
            <th>Valor</th>
            <th>Pagamento</th>
            <th>Finalizar</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {agendamentos.map(a => (
            <tr key={a.id} className={a.finalizado ? 'row-finalizado' : ''}>
              <td>{a.nomeCliente}</td>
              <td>{a.telefone}</td>
              <td>{a.dataHora ? formatarDataTabela(a.dataHora) : ''}</td>
              <td>{a.dataHora ? new Date(a.dataHora).toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' }) : ''}</td>
              <td>{a.servico}</td>
              <td>{formatarValor(a.valor)}</td>
              <td className="col-pagamento">{labelPagamentos(a)}</td>
              <td style={{textAlign:'center'}}>
                <button className={`btn-finalizar ${a.finalizado ? 'finalizado' : ''}`} onClick={() => finalizar(a.id)}>
                  {a.finalizado ? '✅' : '⬜'}
                </button>
              </td>
              <td>
                <button onClick={() => editar(a)}>✏️</button>
                <button onClick={() => deletar(a.id)}>🗑️</button>
              </td>
            </tr>
          ))}
          {agendamentos.length === 0 && <tr><td colSpan="9" style={{textAlign:'center'}}>Nenhum agendamento</td></tr>}
        </tbody>
      </table>

      {totalPaginas > 1 && (
        <div className="paginacao">
          <button disabled={pagina === 0} onClick={() => setPagina(p => p - 1)}>⬅️ Anterior</button>
          <span>Página {pagina + 1} de {totalPaginas}</span>
          <button disabled={pagina >= totalPaginas - 1} onClick={() => setPagina(p => p + 1)}>Próxima ➡️</button>
        </div>
      )}

    </div>
  );
}

// ==================== TELA 2: RELATÓRIO ====================
function TelaRelatorio({ onNavigate }) {
  const [filtro, setFiltro] = useState('mes');
  const [entradas, setEntradas] = useState([]);
  const [fiados, setFiados] = useState([]);
  const [saidas, setSaidas] = useState([]);
  const [dataInicio, setDataInicio] = useState(hojeDate());
  const [dataFim, setDataFim] = useState(hojeDate());

  const carregar = () => {
    let inicio, fim;
    if (filtro === 'personalizado') {
      inicio = dataInicio + 'T00:00:00';
      fim = dataFim + 'T23:59:59';
    } else {
      const r = getInicioFim(filtro);
      inicio = r.inicio; fim = r.fim;
    }
    const idEstab = getIdEstabelecimento();
    axios.get(`${API}/agendamentos/finalizados?idEstab=${idEstab}&inicio=${inicio}&fim=${fim}`).then(r => setEntradas(r.data));
    axios.get(`${API}/agendamentos/fiados?idEstab=${idEstab}&inicio=${inicio}&fim=${fim}`).then(r => setFiados(r.data));
    axios.get(`${API}/saidas/periodo?idEstab=${idEstab}&inicio=${inicio.slice(0,10)}&fim=${fim.slice(0,10)}`).then(r => setSaidas(r.data));
  };
  useEffect(() => { carregar(); }, [filtro, dataInicio, dataFim]);

  const totalEntradas = entradas.reduce((s, a) => {
    if (a.pagamentos && a.pagamentos.length > 0) {
      return s + a.pagamentos.filter(p => p.formaPagamento !== 'FIADO' || a.fiadoPago).reduce((sp, p) => sp + parseFloat(p.valor), 0);
    }
    if (a.formaPagamento === 'FIADO' && !a.fiadoPago) return s;
    return s + parseFloat(a.valor);
  }, 0);
  const totalFiados = fiados.reduce((s, a) => {
    if (a.pagamentos && a.pagamentos.length > 0) {
      return s + a.pagamentos.filter(p => p.formaPagamento === 'FIADO').reduce((sp, p) => sp + parseFloat(p.valor), 0);
    }
    return s + parseFloat(a.valor);
  }, 0);
  const totalSaidas = saidas.reduce((s, e) => s + parseFloat(e.valor), 0);
  const saldo = totalEntradas - totalSaidas;

  return (
    <div className="container">
      <h1>📊 Relatório Financeiro</h1>
      <div className="filtro-bar">
        <label>Filtrar por:</label>
        <button className={filtro === 'semana' ? 'active' : ''} onClick={() => setFiltro('semana')}>Semana</button>
        <button className={filtro === 'mes' ? 'active' : ''} onClick={() => setFiltro('mes')}>Mês</button>
        <button className={filtro === 'ano' ? 'active' : ''} onClick={() => setFiltro('ano')}>Ano</button>
        <button className={filtro === 'personalizado' ? 'active' : ''} onClick={() => setFiltro('personalizado')}>Personalizado</button>
        {filtro === 'personalizado' && (
          <div style={{display:'flex',gap:'0.3rem',alignItems:'center',marginLeft:'0.5rem'}}>
            <input type="date" value={dataInicio} onChange={e => setDataInicio(e.target.value)} style={{fontSize:'0.8rem',padding:'0.2rem'}} />
            <span>a</span>
            <input type="date" value={dataFim} onChange={e => setDataFim(e.target.value)} style={{fontSize:'0.8rem',padding:'0.2rem'}} />
          </div>
        )}
      </div>
      <h2>Entradas (Finalizados)</h2>
      <table>
        <thead><tr><th>Cliente</th><th>Data</th><th>Hora</th><th>Serviço</th><th>Valor</th><th>Pagamento</th></tr></thead>
        <tbody>
          {entradas.map(a => (
            <tr key={a.id}>
              <td>{a.nomeCliente}</td>
              <td>{a.dataHora ? formatarDataTabela(a.dataHora) : ''}</td>
              <td>{a.dataHora ? new Date(a.dataHora).toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' }) : ''}</td>
              <td>{a.servico}</td>
              <td>{formatarValor(a.valor)}</td>
              <td>{labelPagamentos(a)}</td>
            </tr>
          ))}
          {entradas.length === 0 && <tr><td colSpan="6" style={{textAlign:'center'}}>Nenhuma entrada finalizada no período</td></tr>}
        </tbody>
        <tfoot>
          <tr className="total-row entrada">
            <td colSpan="4" style={{textAlign:'right',fontWeight:700}}>Total Entradas:</td>
            <td style={{fontWeight:700}}>{formatarValor(totalEntradas)}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>

      <h2 style={{marginTop:'2rem'}}>⚠️ Fiados pendentes (não contabilizado no caixa)</h2>
      <table>
        <thead><tr><th>Cliente</th><th>Data</th><th>Hora</th><th>Serviço</th><th>Valor</th><th>Pago?</th></tr></thead>
        <tbody>
          {fiados.map(a => (
            <tr key={a.id} className="row-fiado">
              <td>{a.nomeCliente}</td>
              <td>{a.dataHora ? formatarDataTabela(a.dataHora) : ''}</td>
              <td>{a.dataHora ? new Date(a.dataHora).toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' }) : ''}</td>
              <td>{a.servico}</td>
              <td className="valor-fiado">{formatarValor(a.pagamentos && a.pagamentos.length > 0 ? a.pagamentos.filter(p => p.formaPagamento === 'FIADO').reduce((s, p) => s + parseFloat(p.valor), 0) : a.valor)}</td>
              <td style={{textAlign:'center'}}>
                <button className="btn-pagar-fiado" onClick={async () => { await axios.patch(`${API}/agendamentos/${a.id}/pagar-fiado`); carregar(); }}>💰 Pago</button>
              </td>
            </tr>
          ))}
          {fiados.length === 0 && <tr><td colSpan="6" style={{textAlign:'center'}}>Nenhum fiado pendente no período</td></tr>}
        </tbody>
        <tfoot>
          <tr className="total-row fiado-total">
            <td colSpan="4" style={{textAlign:'right',fontWeight:700}}>Total Fiados Pendentes:</td>
            <td className="valor-fiado" style={{fontWeight:700}}>{formatarValor(totalFiados)}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>

      <h2 style={{marginTop:'2rem'}}>Saídas</h2>
      <table>
        <thead><tr><th>Data</th><th>Descrição</th><th>Valor</th></tr></thead>
        <tbody>
          {saidas.map(s => (
            <tr key={s.id}>
              <td>{formatarDataCurta(s.data)}</td>
              <td>{s.descricao}</td>
              <td>{formatarValor(s.valor)}</td>
            </tr>
          ))}
          {saidas.length === 0 && <tr><td colSpan="3" style={{textAlign:'center'}}>Nenhuma saída no período</td></tr>}
        </tbody>
        <tfoot>
          <tr className="total-row saida-total">
            <td colSpan="2" style={{textAlign:'right',fontWeight:700}}>Total Saídas:</td>
            <td style={{fontWeight:700}}>{formatarValor(totalSaidas)}</td>
          </tr>
        </tfoot>
      </table>
      <div className={`saldo-geral ${saldo >= 0 ? 'positivo' : 'negativo'}`}>Saldo do Período: {formatarValor(saldo)}</div>
    </div>
  );
}

// ==================== TELA 3: CADASTRO DE SAÍDA ====================
function TelaSaida({ onNavigate }) {
  const [form, setForm] = useState({ descricao: '', valor: '', data: hojeDate() });
  const [mensagem, setMensagem] = useState('');
  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = async e => {
    e.preventDefault();
    await axios.post(`${API}/saidas`, { ...form, valor: parseFloat(form.valor), idEstabelecimento: getIdEstabelecimento() });
    setForm({ descricao: '', valor: '', data: hojeDate() });
    setMensagem('Saída cadastrada com sucesso!');
    setTimeout(() => setMensagem(''), 3000);
  };
  return (
    <div className="container">
      <h1>💸 Cadastrar Saída</h1>
      {mensagem && <div className="mensagem-sucesso">{mensagem}</div>}
      <form onSubmit={handleSubmit} className="form">
        <div className="form-grid">
          <label>Data<input type="date" name="data" value={form.data} onChange={handleChange} required /></label>
          <label>Descrição da Saída<input type="text" name="descricao" value={form.descricao} onChange={handleChange} required /></label>
          <label>Valor (R$)<input type="number" name="valor" value={form.valor} onChange={handleChange} required min="0" step="0.01" /></label>
        </div>
        <div className="form-actions">
          <button type="submit">Salvar Saída</button>
          <button type="button" className="btn-voltar" onClick={() => onNavigate('relatorio')}>⬅️ Voltar ao Relatório</button>
        </div>
      </form>
    </div>
  );
}

const DIAS_SEMANA = ['Domingo','Segunda-feira','Terça-feira','Quarta-feira','Quinta-feira','Sexta-feira','Sábado'];

function getDiasSemana() {
  const now = new Date(); const day = now.getDay();
  const domingo = new Date(now); domingo.setDate(now.getDate() - day); domingo.setHours(0,0,0,0);
  const dias = [];
  for (let i = 0; i < 7; i++) { const d = new Date(domingo); d.setDate(domingo.getDate() + i); dias.push(d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0')); }
  return dias;
}

// ==================== TELA 4: AGENDA DA SEMANA ====================
function TelaSemana({ onNavigate }) {
  const [hoje, setHoje] = useState([]);
  const [semanaCompleta, setSemanaCompleta] = useState([]);
  const [offset, setOffset] = useState(0);
  const [clientes, setClientes] = useState([]);

  const getSemana = (off) => {
    const now = new Date(); const day = now.getDay();
    const domingo = new Date(now); domingo.setDate(now.getDate() - day + (off * 7)); domingo.setHours(0,0,0,0);
    const dias = [];
    for (let i = 0; i < 7; i++) { const d = new Date(domingo); d.setDate(domingo.getDate() + i); dias.push(d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0')); }
    const inicio = dias[0] + 'T00:00:00';
    const fim = dias[6] + 'T23:59:59';
    return { dias, inicio, fim };
  };

  const now = new Date();
  const hojeStr = now.getFullYear() + '-' + String(now.getMonth()+1).padStart(2,'0') + '-' + String(now.getDate()).padStart(2,'0');

  useEffect(() => {
    const idEstab = getIdEstabelecimento();
    if (!idEstab) return;
    const { inicio, fim } = getSemana(offset);
    axios.get(`${API}/agendamentos/periodo?idEstab=${idEstab}&inicio=${inicio}&fim=${fim}`).then(r => setSemanaCompleta(r.data));
    axios.get(`${API}/clientes?idEstab=${idEstab}`).then(r => setClientes(r.data));
    if (offset === 0) {
      const diaHoje = getInicioFimHoje();
      axios.get(`${API}/agendamentos/periodo?idEstab=${idEstab}&inicio=${diaHoje.inicio}&fim=${diaHoje.fim}`).then(r => setHoje(r.data));
    } else {
      setHoje([]);
    }
  }, [offset]);

  const diasSemana = getSemana(offset).dias;
  const agendamentosDoDia = dia => semanaCompleta.filter(a => a.dataHora && a.dataHora.startsWith(dia));

  const finalizar = async id => {
    await axios.patch(`${API}/agendamentos/${id}/finalizar`);
    const { inicio, fim } = getSemana(offset);
    const idEstab = getIdEstabelecimento();
    axios.get(`${API}/agendamentos/periodo?idEstab=${idEstab}&inicio=${inicio}&fim=${fim}`).then(r => setSemanaCompleta(r.data));
    if (offset === 0) {
      const diaHoje = getInicioFimHoje();
      axios.get(`${API}/agendamentos/periodo?idEstab=${idEstab}&inicio=${diaHoje.inicio}&fim=${diaHoje.fim}`).then(r => setHoje(r.data));
    }
  };

  const deletar = async id => {
    if (window.confirm('Deseja excluir este agendamento?')) {
      await axios.delete(`${API}/agendamentos/${id}`);
      const { inicio, fim } = getSemana(offset);
      const idEstab = getIdEstabelecimento();
      axios.get(`${API}/agendamentos/periodo?idEstab=${idEstab}&inicio=${inicio}&fim=${fim}`).then(r => setSemanaCompleta(r.data));
      if (offset === 0) {
        const diaHoje = getInicioFimHoje();
        axios.get(`${API}/agendamentos/periodo?idEstab=${idEstab}&inicio=${diaHoje.inicio}&fim=${diaHoje.fim}`).then(r => setHoje(r.data));
      }
    }
  };

  const editar = a => {
    onNavigate('home');
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('editarAgendamento', { detail: a }));
    }, 100);
  };

  const agendarNoDia = (dia) => {
    onNavigate('home');
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('agendarNoDia', { detail: { data: dia } }));
    }, 100);
  };

  const TabelaDia = ({ lista, vazio }) => (
    <table>
      <thead><tr><th>Cliente</th><th>Data/Hora</th><th>Serviço</th><th>Valor</th><th>Finalizar</th><th>Ações</th></tr></thead>
      <tbody>
        {lista.map(a => (
          <tr key={a.id} className={a.finalizado ? 'row-finalizado' : ''}>
            <td>{a.nomeCliente}</td>
            <td>{a.dataHora ? formatarDataTabela(a.dataHora)+' '+new Date(a.dataHora).toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' }) : ''}</td>
            <td>{a.servico}</td>
            <td>{formatarValor(a.valor)}</td>
            <td style={{textAlign:'center'}}>
              <button className={`btn-finalizar ${a.finalizado ? 'finalizado' : ''}`} onClick={() => finalizar(a.id)}>
                {a.finalizado ? '✅' : '⬜'}
              </button>
            </td>
            <td>
              <button onClick={() => editar(a)}><img src="/icons/editar.png" alt="Editar" className="icon-btn" /></button>
              <button onClick={() => deletar(a.id)}><img src="/icons/lixeira.jpg" alt="Excluir" className="icon-btn" /></button>
              <button onClick={() => { const c = clientes.find(cl => cl.nome.toLowerCase() === a.nomeCliente.toLowerCase()); if(c) onNavigate('anamnese-'+c.id+'-semana'); else alert('Cliente não encontrado no cadastro'); }} title="Anamnese"><img src="/icons/prancheta.png" alt="Anamnese" className="icon-btn" /></button>
            </td>
          </tr>
        ))}
        {lista.length === 0 && <tr><td colSpan="6" style={{textAlign:'center'}}>{vazio}</td></tr>}
      </tbody>
    </table>
  );

  return (
    <div className="container tela-semana">
      <Header />
      <h1>📋 Agenda da Semana</h1>

      <div className="semana-nav">
        <button onClick={() => setOffset(o => o - 1)}>⬅️ Semana anterior</button>
        {offset !== 0 && <button onClick={() => setOffset(0)}>Semana atual</button>}
        <button onClick={() => setOffset(o => o + 1)}>Semana seguinte ➡️</button>
      </div>

      {offset === 0 && (
        <div className="card-destaque">
          <h2>📌 Hoje — {DIAS_SEMANA[new Date().getDay()]}</h2>
          <TabelaDia lista={hoje} vazio="Nenhum agendamento para hoje" />
        </div>
      )}

      <div className="card-semana">
        <h2>📅 Visão Geral da Semana</h2>
        {diasSemana.filter(d => offset !== 0 || d !== hojeStr).map(dia => {
          const ags = agendamentosDoDia(dia);
          const diaIdx = new Date(dia + 'T12:00:00').getDay();
          const dataFmt = new Date(dia + 'T12:00:00').toLocaleDateString('pt-BR');
          return (
            <div key={dia} className="dia-semana">
              <h3>{DIAS_SEMANA[diaIdx]} — {dataFmt} <button className="btn-agendar-dia" onClick={() => agendarNoDia(dia)} title="Agendar neste dia">➕</button></h3>
              {ags.length > 0 ? <TabelaDia lista={ags} vazio="" /> : <p className="sem-agendamento">Nenhum agendamento</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ==================== TELA 5: HISTÓRICO ====================
function TelaHistorico({ onNavigate }) {
  const [historico, setHistorico] = useState([]);
  useEffect(() => { axios.get(`${API}/historico`).then(r => setHistorico(r.data)); }, []);
  const labelAcao = acao => ({ CRIADO:'🆕 Criado', EDITADO:'✏️ Editado', 'EXCLUÍDO':'🗑️ Excluído', FINALIZADO:'✅ Finalizado', REABERTO:'🔄 Reaberto' }[acao] || acao);
  return (
    <div className="container">
      <h1>🕓 Histórico de Alterações</h1>
      <table>
        <thead><tr><th>Data/Hora</th><th>Agendamento #</th><th>Ação</th><th>Detalhes</th></tr></thead>
        <tbody>
          {historico.map(h => (
            <tr key={h.id}>
              <td>{formatarData(h.dataAlteracao)}</td>
              <td style={{textAlign:'center'}}>{h.agendamentoId}</td>
              <td>{labelAcao(h.acao)}</td>
              <td>{h.descricao}</td>
            </tr>
          ))}
          {historico.length === 0 && <tr><td colSpan="4" style={{textAlign:'center'}}>Nenhum registro no histórico</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

// ==================== TELA 6: CADASTRO DE CLIENTES ====================
function TelaClientes({ onNavigate }) {
  const [clientes, setClientes] = useState([]);
  const [form, setForm] = useState({ nome: '', telefone: '', dataNascimento: '' });
  const [editId, setEditId] = useState(null);
  const [mensagem, setMensagem] = useState('');
  const [filtro, setFiltro] = useState('todos');
  const [devedores, setDevedores] = useState([]);
  const [aniversariantes, setAniversariantes] = useState([]);

  const carregar = () => axios.get(`${API}/clientes?idEstab=${getIdEstabelecimento()}`).then(r => setClientes(r.data));
  useEffect(() => { carregar(); }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === 'telefone') { setForm({ ...form, telefone: mascaraTelefone(value) }); return; }
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const payload = { ...form, dataNascimento: form.dataNascimento || null, idEstabelecimento: getIdEstabelecimento() };
    if (editId) {
      await axios.put(`${API}/clientes/${editId}`, payload);
      setMensagem('Cliente atualizado!');
    } else {
      await axios.post(`${API}/clientes`, payload);
      setMensagem('Cliente cadastrado!');
    }
    setForm({ nome: '', telefone: '', dataNascimento: '' }); setEditId(null);
    setTimeout(() => setMensagem(''), 3000);
    carregar();
  };

  const editar = c => {
    setForm({ nome: c.nome, telefone: c.telefone, dataNascimento: c.dataNascimento || '' });
    setEditId(c.id);
  };

  const deletar = async id => {
    if (window.confirm('Deseja excluir este cliente?')) {
      await axios.delete(`${API}/clientes/${id}`); carregar();
    }
  };

  const mostrarDevedores = async () => {
    if (filtro === 'devedores') { setFiltro('todos'); return; }
    const r = await axios.get(`${API}/clientes/devedores?idEstab=${getIdEstabelecimento()}`);
    setDevedores(r.data);
    setFiltro('devedores');
  };

  const mostrarAniversariantes = async () => {
    if (filtro === 'aniversariantes') { setFiltro('todos'); return; }
    const r = await axios.get(`${API}/clientes/aniversariantes?idEstab=${getIdEstabelecimento()}`);
    setAniversariantes(r.data);
    setFiltro('aniversariantes');
  };

  let listaExibida = clientes;
  if (filtro === 'devedores') listaExibida = clientes.filter(c => devedores.includes(c.nome));
  if (filtro === 'aniversariantes') listaExibida = aniversariantes;

  return (
    <div className="container">
      <h1>👤 Cadastro de Clientes</h1>

      {mensagem && <div className="mensagem-sucesso">{mensagem}</div>}

      <form onSubmit={handleSubmit} className="form">
        <div className="form-grid">
          <label>Nome<input type="text" name="nome" value={form.nome} onChange={handleChange} required /></label>
          <label>Telefone<input type="tel" name="telefone" value={form.telefone} onChange={handleChange} required placeholder="(00) 00000-0000" /></label>
          <label>Data de Nascimento<input type="date" name="dataNascimento" value={form.dataNascimento} onChange={handleChange} /></label>
        </div>
        <div className="form-actions">
          <button type="submit">{editId ? 'Atualizar' : 'Cadastrar'}</button>
          {editId && <button type="button" onClick={() => { setForm({ nome: '', telefone: '', dataNascimento: '' }); setEditId(null); }}>Cancelar</button>}
        </div>
      </form>

      <div className="filtro-bar">
        <button className={filtro === 'devedores' ? 'active' : ''} onClick={mostrarDevedores}>💳 Devedores</button>
        <button className={filtro === 'aniversariantes' ? 'active' : ''} onClick={mostrarAniversariantes}>🎂 Aniversários do Mês</button>
        {filtro !== 'todos' && <button onClick={() => setFiltro('todos')}>✕ Limpar filtro</button>}
      </div>

      <table>
        <thead><tr><th>Nome</th><th>Telefone</th><th>Nascimento</th><th>Anamnese</th><th>Ações</th></tr></thead>
        <tbody>
          {listaExibida.map(c => (
            <tr key={c.id}>
              <td>{c.nome}</td>
              <td>{c.telefone}</td>
              <td>{c.dataNascimento ? formatarDataCurta(c.dataNascimento) : '—'}</td>
              <td><button className="btn-anamnese" onClick={() => onNavigate('anamnese-' + c.id)}>📋</button></td>
              <td>
                <button onClick={() => editar(c)}>✏️</button>
                <button onClick={() => deletar(c.id)}>🗑️</button>
              </td>
            </tr>
          ))}
          {listaExibida.length === 0 && <tr><td colSpan="5" style={{textAlign:'center'}}>{filtro === 'devedores' ? 'Nenhum devedor' : filtro === 'aniversariantes' ? 'Nenhum aniversário este mês' : 'Nenhum cliente cadastrado'}</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

// ==================== TELA 7: ANAMNESE ====================
const ABAS_ANAMNESE = ['Facial','Corporal','Capilar','Podal','Massoterapia','Anamnese Antiga'];

function TelaAnamnese({ idCliente, origem, onNavigate }) {
  const voltarPara = origem === 'semana' ? 'semana' : 'clientes';
  const labelVoltar = origem === 'semana' ? '⬅️ Voltar à Agenda' : '⬅️ Voltar aos Clientes';
  const [abaAtiva, setAbaAtiva] = useState('Facial');
  const [form, setForm] = useState({ queixa:'',quantoTempo:'',tratamentoAnterior:'',casosFamilia:'',rotinaAlimentar:'',rotinaCuidados:'',fumanteEtilista:'',problemaSaude:'',alergia:'',cirurgiaRecente:'',medicacaoContinua:'',examesDia:'',achadosDermatoscopico:'',achadosFisico:'',pesoAtual:'',imc:'',gorduraCorporal:'',musculoEsqueletico:'',gorduraVisceral:'',metabolismoRepouso:'',idadeBiologica:'',sugestaoDiagnostica:'',tratamentoSugerido:'',anotacoesFuturas:'',observacoes:'',dataPreenchimento:null });
  const [nomeCliente, setNomeCliente] = useState('');
  const [idadeCliente, setIdadeCliente] = useState(null);
  const [msg, setMsg] = useState('');
  const [fotos, setFotos] = useState([]);
  const [fotoAmpliada, setFotoAmpliada] = useState(null);
  const [uploading, setUploading] = useState(false);
  const carregarFotos = (tipo) => axios.get(`${API}/fotos-anamnese/cliente/${idCliente}?tipoAnamnese=${tipo || abaAtiva}`).then(r => setFotos(r.data));
  const uploadFoto = async (e) => { const file=e.target.files[0]; if(!file)return; setUploading(true); const fd=new FormData(); fd.append('file',file); fd.append('tipoAnamnese',abaAtiva); try{await axios.post(`${API}/fotos-anamnese/upload/${idCliente}`,fd);carregarFotos();}catch(err){alert(typeof err.response?.data==='string'?err.response.data:'Erro ao enviar foto');} setUploading(false); e.target.value=''; };
  const [historicoBio, setHistoricoBio] = useState([]);
  const carregarHistorico = () => axios.get(`${API}/anamnese/historico-bio/${idCliente}`).then(r => setHistoricoBio(r.data));
  useEffect(() => {
    axios.get(`${API}/anamnese/${idCliente}`).then(r => {
      if (r.data && r.data.id) {
        let dados = {...r.data};
        if (dados.dadosEspecificos) {
          try { Object.assign(dados, JSON.parse(dados.dadosEspecificos)); } catch(e) {}
        }
        setForm(prev => ({...prev,...dados}));
      }
    });
    axios.get(`${API}/clientes?idEstab=${getIdEstabelecimento()}`).then(r => {
      const c = r.data.find(cl => cl.id === parseInt(idCliente));
      if (c) { setNomeCliente(c.nome); if (c.dataNascimento) { const nasc = new Date(c.dataNascimento+'T00:00:00'); const hoje = new Date(); let idade = hoje.getFullYear()-nasc.getFullYear(); if (hoje.getMonth()<nasc.getMonth()||(hoje.getMonth()===nasc.getMonth()&&hoje.getDate()<nasc.getDate())) idade--; setIdadeCliente(idade); } }
    });
    carregarFotos(abaAtiva);
    carregarHistorico();
  }, [idCliente]);
  useEffect(() => { carregarFotos(abaAtiva); }, [abaAtiva]);
  const handleText = e => {
    const {name, value} = e.target;
    const f = {...form, [name]: value};
    if (name === 'imcValor') {
      const v = parseFloat(value);
      if (!isNaN(v)) { if(v<18.5) f.imc='Menos de 18,5 - Abaixo do peso'; else if(v<=25) f.imc='18,5 a 25 - Normal'; else if(v<=30) f.imc='26 a 30 - Sobrepeso'; else f.imc='30 ou mais - Obeso'; }
    }
    if (name === 'gorduraVisceralValor') {
      const v = parseFloat(value);
      if (!isNaN(v)) { if(v<=9) f.gorduraVisceral='Menor ou igual a 9 - Normal'; else if(v<=14) f.gorduraVisceral='Entre 10 e 14 - N\u00edvel alto'; else f.gorduraVisceral='Maior ou igual a 15 - N\u00edvel muito alto'; }
    }
    if (name === 'gorduraCorporalValor') {
      const v = parseFloat(value);
      const idade = idadeCliente || 30;
      if (!isNaN(v)) {
        if (idade >= 29 && idade <= 39) { if(v<21) f.gorduraCorporal='29-39: Menor que 21.0 - Baixa'; else if(v<=32.9) f.gorduraCorporal='29-39: 21.0 a 32.9 - Normal'; else if(v<=38.9) f.gorduraCorporal='29-39: 33.0 a 38.9 - Alta'; else f.gorduraCorporal='29-39: Maior que 39.0 - Muito alta'; }
        else if (idade >= 40 && idade <= 59) { if(v<23) f.gorduraCorporal='40-59: Menor que 23.0 - Baixa'; else if(v<=33.9) f.gorduraCorporal='40-59: 23.0 a 33.9 - Normal'; else if(v<=39.9) f.gorduraCorporal='40-59: 34.0 a 39.9 - Alta'; else f.gorduraCorporal='40-59: Maior que 40.0 - Muito alta'; }
        else if (idade >= 60) { if(v<24) f.gorduraCorporal='60-79: Menor que 24.0 - Baixa'; else if(v<=35.9) f.gorduraCorporal='60-79: 24.0 a 35.9 - Normal'; else if(v<=41.9) f.gorduraCorporal='60-79: 36.0 a 41.9 - Alta'; else f.gorduraCorporal='60-79: Maior que 42.0 - Muito alta'; }
      }
    }
    if (name === 'musculoEsqueleticoValor') {
      const v = parseFloat(value);
      const idade = idadeCliente || 30;
      if (!isNaN(v)) {
        if (idade >= 18 && idade <= 39) { if(v<24.3) f.musculoEsqueletico='18-39: Menor que 24.3 - Baixa'; else if(v<=30.3) f.musculoEsqueletico='18-39: 24.3 a 30.3 - Normal'; else if(v<=35.3) f.musculoEsqueletico='18-39: 30.4 a 35.3 - Alta'; else f.musculoEsqueletico='18-39: Maior que 35.4 - Muito alta'; }
        else if (idade >= 40 && idade <= 59) { if(v<24.1) f.musculoEsqueletico='40-59: Menor que 24.1 - Baixa'; else if(v<=30.1) f.musculoEsqueletico='40-59: 24.1 a 30.1 - Normal'; else if(v<=35.1) f.musculoEsqueletico='40-59: 30.2 a 35.1 - Alta'; else f.musculoEsqueletico='40-59: Maior que 35.2 - Muito alta'; }
        else if (idade >= 60) { if(v<23.9) f.musculoEsqueletico='60-80: Menor que 23.9 - Baixa'; else if(v<=29.9) f.musculoEsqueletico='60-80: 23.9 a 29.9 - Normal'; else if(v<=34.9) f.musculoEsqueletico='60-80: 30.0 a 34.9 - Alta'; else f.musculoEsqueletico='60-80: Maior que 35.0 - Muito alta'; }
      }
    }
    setForm(f);
  };
  const salvar = async () => {
    const payload = {...form, idCliente: parseInt(idCliente), tipo: abaAtiva === 'Anamnese Antiga' ? null : abaAtiva.toUpperCase()};
    // Campos específicos da aba em JSON
    const camposEspecificos = {};
    Object.keys(form).forEach(k => {
      if (k.includes('Corporal') || k.includes('prega') || k.includes('circ') || k.includes('tipoGordura') || k.includes('flacidez') || k.includes('diastase') || k.includes('estrias') || k.includes('celulite') || k.includes('grauCelulite') || k.includes('geneticaCorporal') || k.includes('Facial') || k.includes('corPele') || k.includes('biotipo') || k.includes('estado') || k.includes('espessura') || k.includes('grauEnvelhecimento') || k.includes('rugas') || k.includes('flacidez') || k.includes('sequelas') || k.includes('queratinizacao') || k.includes('ptose') || k.includes('acne') || k.includes('manchas') || k.includes('lesoes') || k.includes('frequencia') || k.includes('exposicao') || k.includes('problemas') || k.includes('intestino') || k.includes('ciclo') || k.includes('sono') || k.includes('exercicio') || k.includes('cirurgia')) {
        if (form[k]) camposEspecificos[k] = form[k];
      }
    });
    payload.dadosEspecificos = JSON.stringify(camposEspecificos);
    await axios.post(`${API}/anamnese`, payload);
    setMsg('Anamnese salva com sucesso!');
    setTimeout(() => setMsg(''), 3000);
    carregarHistorico();
  };
  const deletarFoto = async (id) => { if(window.confirm('Excluir esta foto?')){await axios.delete(`${API}/fotos-anamnese/${id}`);carregarFotos();if(fotoAmpliada===id)setFotoAmpliada(null);} };
  const P = (label,campo,rows) => (<div className="anamnese-pergunta"><label className="anamnese-label">{label}</label><textarea className="anamnese-input" name={campo} value={form[campo]||''} onChange={handleText} rows={rows||2} maxLength={500} /></div>);
  const dataAvaliacao = form.dataPreenchimento ? formatarDataCurta(form.dataPreenchimento) : hojeDate().split('-').reverse().join('/');
  const gerarPDF = () => {
    const doc = new jsPDF();
    let y = 15;
    const lm = 15;
    const pw = 180;
    const addTitulo = (t) => { if(y>270){doc.addPage();y=15;} doc.setFontSize(13);doc.setFont('helvetica','bold');doc.text(t,lm,y);y+=8; };
    const addSubtitulo = (t) => { if(y>270){doc.addPage();y=15;} doc.setFontSize(11);doc.setFont('helvetica','bold');doc.text(t,lm,y);y+=7; };
    const addCampo = (label,valor) => { if(y>275){doc.addPage();y=15;} doc.setFontSize(9);doc.setFont('helvetica','bold');doc.text(label,lm,y);doc.setFont('helvetica','normal');const lines=doc.splitTextToSize(valor||'---',pw-5);doc.text(lines,lm+2,y+5);y+=5+(lines.length*4)+3; };
    const addLinha = (t) => { if(y>275){doc.addPage();y=15;} doc.setFontSize(9);doc.setFont('helvetica','normal');doc.text(t||'',lm+2,y);y+=5; };
    doc.setFontSize(16);doc.setFont('helvetica','bold');doc.text('ANAMNESE',105,y,{align:'center'});y+=10;
    doc.setFontSize(10);doc.setFont('helvetica','normal');
    doc.text('Nome: '+nomeCliente+(idadeCliente!==null?' | Idade: '+idadeCliente+' anos':''),lm,y);y+=6;
    doc.text('Data: '+dataAvaliacao,lm,y);y+=4;
    doc.setDrawColor(180);doc.line(lm,y,lm+pw,y);y+=6;
    addTitulo('Avaliacao Pessoal');
    addCampo('Queixa?',form.queixa);
    addCampo('A quanto tempo?',form.quantoTempo);
    addCampo('Ja fez ou faz algum tratamento para resolver?',form.tratamentoAnterior);
    addCampo('Existem casos na familia?',form.casosFamilia);
    addCampo('Rotina alimentar e hidrica?',form.rotinaAlimentar);
    addCampo('Rotina de cuidados com (cabelo/pele/corpo)?',form.rotinaCuidados);
    addCampo('Fumante ou etilista?',form.fumanteEtilista);
    addCampo('Algum problema de saude cronico, agudo ou emocional?',form.problemaSaude);
    addCampo('Algum tipo de alergia?',form.alergia);
    addCampo('Cirurgia ou tratamento nos ultimos 6 meses?',form.cirurgiaRecente);
    addCampo('Medicacao continua?',form.medicacaoContinua);
    addCampo('Exames em dia?',form.examesDia);
    addTitulo('Avaliacao Dermatoscopica');
    addCampo('Achados:',form.achadosDermatoscopico);
    addTitulo('Avaliacao Fisica');
    addCampo('Achados:',form.achadosFisico);
    addTitulo('Avaliacao Bioimpedancia');
    addCampo('Peso atual:',form.pesoAtual);
    addCampo('Metabolismo em repouso (RM):',form.metabolismoRepouso);
    addCampo('Idade biologica:',form.idadeBiologica);
    addSubtitulo('IMC: '+(form.imcValor||''));
    addLinha(form.imc||'Nao informado');
    addSubtitulo('Gordura Corporal: '+(form.gorduraCorporalValor||'')+'%');
    addLinha(form.gorduraCorporal||'Nao informado');
    addSubtitulo('Musculos Esqueletico: '+(form.musculoEsqueleticoValor||'')+'%');
    addLinha(form.musculoEsqueletico||'Nao informado');
    addSubtitulo('Gordura Visceral: '+(form.gorduraVisceralValor||'')+'%');
    addLinha(form.gorduraVisceral||'Nao informado');
    addTitulo('Sugestao Diagnostica');
    addCampo('',form.sugestaoDiagnostica);
    addTitulo('Tratamento Sugerido e Orcamento');
    addCampo('',form.tratamentoSugerido);
    addTitulo('Anotacoes Futuras');
    addCampo('',form.anotacoesFuturas);
    if(form.observacoes){addTitulo('Observacoes');addCampo('',form.observacoes);}
    doc.save('anamnese_'+nomeCliente.replace(/\s/g,'_')+'.pdf');
  };
  return (
    <div className="container">
      <h1>📋 Anamnese</h1>
      <div className="form anamnese-form">
        <div className="anamnese-cliente-info"><span><strong>Nome:</strong> {nomeCliente}</span>{idadeCliente !== null && <span><strong>Idade:</strong> {idadeCliente} anos</span>}</div>

        <div className="abas-anamnese">
          {ABAS_ANAMNESE.map(aba => (
            <button key={aba} className={`aba-btn ${abaAtiva === aba ? 'aba-ativa' : ''}`} onClick={() => setAbaAtiva(aba)}>{aba}</button>
          ))}
        </div>

        {abaAtiva === 'Facial' && (<>
        <div className="anamnese-header"><h2>Anamnese Clínica</h2><span className="anamnese-data">{dataAvaliacao}</span></div>
        <div className="anamnese-inline-group">
          <div className="anamnese-inline"><label>Queixa principal:</label><input type="text" name="queixa" value={form.queixa||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Já fez algum tratamento antes?</label><input type="text" name="tratamentoAnterior" value={form.tratamentoAnterior||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Com que frequência faz limpeza de pele?</label><input type="text" name="frequenciaLimpeza" value={form.frequenciaLimpeza||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Como é sua rotina alimentar e hídrica?</label><input type="text" name="rotinaAlimentar" value={form.rotinaAlimentar||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Etilista ou tabagista?</label><input type="text" name="fumanteEtilista" value={form.fumanteEtilista||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Costuma expor-se ao sol sem protetor solar?</label><input type="text" name="exposicaoSol" value={form.exposicaoSol||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Tem problemas hormonais?</label><input type="text" name="problemasHormonais" value={form.problemasHormonais||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Faz uso de algum medicamento contínuo?</label><input type="text" name="medicacaoContinua" value={form.medicacaoContinua||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Seu intestino funciona bem?</label><input type="text" name="intestino" value={form.intestino||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Como é sua rotina de higienização da face?</label><input type="text" name="rotinaCuidados" value={form.rotinaCuidados||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Alguma doença crônica ou alergia?</label><input type="text" name="alergia" value={form.alergia||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Ciclo menstrual normal?</label><input type="text" name="cicloMenstrual" value={form.cicloMenstrual||''} onChange={handleText} /></div>
        </div>

        <div className="anamnese-secao"><h2>Anamnese física e tricoscópica</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha"><strong>Cor da pele:</strong>
            {['Branca','Parda','Preta'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="corPele" value={op} checked={form.corPele===op} onChange={handleText} />{op}</label>))}
          </div>
          <div className="anamnese-radio-linha"><strong>Biotipo cutâneo:</strong>
            {['Normal','Mista','Oleosa','Seca'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="biotipoCutaneo" value={op} checked={form.biotipoCutaneo===op} onChange={handleText} />{op}</label>))}
          </div>
          <div className="anamnese-radio-linha"><strong>Estado cutâneo:</strong>
            {['Normal','Desidratado','Sensibilizado','Acneico','Seborreico'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="estadoCutaneo" value={op} checked={form.estadoCutaneo===op} onChange={handleText} />{op}</label>))}
          </div>
          <div className="anamnese-radio-linha"><strong>Espessura cutânea:</strong>
            {['Fina','Muito fina','Normal','Espessa','Muito espessa'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="espessuraCutanea" value={op} checked={form.espessuraCutanea===op} onChange={handleText} />{op}</label>))}
          </div>
          <div className="anamnese-radio-linha"><strong>Grau de envelhecimento (Glogau):</strong>
            {['Leve','Moderado','Avançado','Severo'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="grauEnvelhecimento" value={op} checked={form.grauEnvelhecimento===op} onChange={handleText} />{op}</label>))}
          </div>
          <div className="anamnese-radio-linha"><strong>Rugas:</strong>
            {['Superficiais','Médias','Profundas'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="rugas" value={op} checked={form.rugas===op} onChange={handleText} />{op}</label>))}
            <label className="anamnese-radio-inline">Onde? <input type="text" name="rugasOnde" value={form.rugasOnde||''} onChange={handleText} style={{width:'120px',marginLeft:'4px'}} /></label>
          </div>
          <div className="anamnese-radio-linha"><strong>Flacidez:</strong>
            {['Sim','Não'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="flacidez" value={op} checked={form.flacidez===op} onChange={handleText} />{op}</label>))}
          </div>
          <div className="anamnese-radio-linha"><strong>Sequelas:</strong>
            {['Atrofias','Cicatrizes','Queloide'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="checkbox" name="sequelas" value={op} checked={(form.sequelas||'').includes(op)} onChange={e => { const arr = (form.sequelas||'').split(',').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'sequelas',value:arr.join(',')}}); }} />{op}</label>))}
          </div>
          <div className="anamnese-radio-linha"><strong>Queratinização:</strong>
            {['Psoríase','Verrugas'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="checkbox" name="queratinizacao" value={op} checked={(form.queratinizacao||'').includes(op)} onChange={e => { const arr = (form.queratinizacao||'').split(',').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'queratinizacao',value:arr.join(',')}}); }} />{op}</label>))}
          </div>
          <div className="anamnese-radio-linha"><strong>Ptose:</strong>
            {['Sim','Não'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="ptose" value={op} checked={form.ptose===op} onChange={handleText} />{op}</label>))}
          </div>
        </div>

        <div className="anamnese-secao"><h2>Manchas pigmentadas relacionadas a melanina</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha">
            {['Acromia - diminuição e ausência de melanina, manchas brancas','Hipercromia - exagerada produção de melanina (envelhecimento, alterações hormonais, inflamações, alergias, exposição solar)','Cloasma - manchas escuras que surgem na pele durante a gravidez'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="manchasMelanina" value={op} checked={(form.manchasMelanina||'').includes(op)} onChange={e => { const arr = (form.manchasMelanina||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'manchasMelanina',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
        </div>

        <div className="anamnese-secao"><h2>Manchas por alterações vasculares</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha">
            {['Angioma - manchas vermelhas ou tumores vasculares benignos','Cianose - tom azulado em baixo das unhas ou mucosas','Eritema - manchas vermelhas, reaparece quando a pressão acaba','Hematoma - acúmulo de sangue fora dos vasos sanguíneos','Rosácea - pequenos vasos finos e superficiais'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="manchasVasculares" value={op} checked={(form.manchasVasculares||'').includes(op)} onChange={e => { const arr = (form.manchasVasculares||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'manchasVasculares',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
        </div>

        <div className="anamnese-secao"><h2>Acne</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha">
            {['Grau 1 - Comedogênica (comedões abertos e fechados sem sinais inflamatórios)','Grau 2 - Pápulo pustulosa (comedões, pápulas vermelhas e pústulas com pus)','Grau 3 - Nódulo-cística (cistos profundos, dolorosos e inflamados)','Grau 4 - Conglobata (nódulos, abscessos e cistos purulentos intercomunicantes)','Grau 5 - Fulminante (surgimento súbito, lesões graves, cicatrizes, dor e febre)'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="radio" name="acne" value={op} checked={form.acne===op} onChange={handleText} /><span>{op}</span></label>))}
          </div>
        </div>

        <div className="anamnese-secao"><h2>Lesões Tecidual</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha">
            {['Crosta - dessecação de sangue, líquido inflamatório ou pus de lesão subjacente','Descamação - camadas superficiais da pele sendo eliminadas','Escara - feridas por permanecer muito tempo na mesma posição','Escoriação - ferimentos simples na camada mais superficial da pele','Ulceração - ferimentos graves na camada mais profunda da pele'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="lesoesTecidual" value={op} checked={(form.lesoesTecidual||'').includes(op)} onChange={e => { const arr = (form.lesoesTecidual||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'lesoesTecidual',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
        </div>

        <div className="anamnese-secao"><h2>Sugestão Diagnóstica</h2></div>
        {P("","sugestaoDiagnostica",3)}
        <div className="anamnese-secao"><h2>Tratamento Sugerido e Orçamento</h2></div>
        {P("","tratamentoSugerido",3)}
        <div className="anamnese-secao"><h2>Anotações Futuras</h2></div>
        {P("","anotacoesFuturas",4)}
        <div className="fotos-section-inline"><h2>📷 Imagens (antes e depois)</h2>
          <label className="btn-upload-foto">{uploading ? 'Enviando...' : '➕ Adicionar Foto'}<input type="file" accept="image/jpeg,image/png,image/webp" onChange={uploadFoto} hidden /></label>
          <div className="fotos-grid">{fotos.map(f => (<div key={f.id} className="foto-thumb-container"><img src={`${API}/fotos-anamnese/imagem/${f.id}`} alt={f.descricao} className="foto-thumb" onClick={() => setFotoAmpliada(fotoAmpliada===f.id?null:f.id)} /><input type="date" className="foto-data-input" value={f.dataFoto || (f.dataCriacao ? f.dataCriacao.slice(0,10) : '')} onChange={async (e) => { await axios.post(`${API}/fotos-anamnese/atualizar-data/${f.id}`, {dataFoto: e.target.value}); carregarFotos(); }} /><button className="foto-delete" onClick={() => deletarFoto(f.id)}>✕</button></div>))}{fotos.length===0 && <p className="sem-agendamento">Nenhuma foto adicionada</p>}</div>
        </div>
        <div className="form-actions"><button type="button" onClick={salvar}>Salvar Anamnese</button><button type="button" onClick={gerarPDF} className="btn-pdf">📄 Gerar PDF</button><button type="button" className="btn-voltar" onClick={() => onNavigate(voltarPara)}>{labelVoltar}</button></div>
        {msg && <div className="mensagem-sucesso" style={{marginTop:'1rem'}}>{msg}</div>}
        </>)}

        {abaAtiva === 'Corporal' && (<>
        <div className="anamnese-header"><h2>Anamnese Clínica</h2><span className="anamnese-data">{dataAvaliacao}</span></div>
        <div className="anamnese-inline-group">
          <div className="anamnese-inline"><label>Queixa principal:</label><input type="text" name="queixaCorporal" value={form.queixaCorporal||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Já fez algum tratamento antes?</label><input type="text" name="tratamentoAnteriorCorporal" value={form.tratamentoAnteriorCorporal||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Como é sua rotina alimentar e hídrica?</label><input type="text" name="rotinaAlimentarCorporal" value={form.rotinaAlimentarCorporal||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Etilista ou tabagista?</label><input type="text" name="etilistaTabagistaCorporal" value={form.etilistaTabagistaCorporal||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Seu intestino funciona bem?</label><input type="text" name="intestinoCorporal" value={form.intestinoCorporal||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Tem problemas hormonais ou circulatórios?</label><input type="text" name="problemasHormonaisCorporal" value={form.problemasHormonaisCorporal||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Faz uso de algum medicamento contínuo?</label><input type="text" name="medicacaoCorporal" value={form.medicacaoCorporal||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Dorme bem? Acorda cansada?</label><input type="text" name="sonoCorporal" value={form.sonoCorporal||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Alguma cirurgia nos últimos 12 meses?</label><input type="text" name="cirurgiaCorporal" value={form.cirurgiaCorporal||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Faz exercício físico?</label><input type="text" name="exercicioCorporal" value={form.exercicioCorporal||''} onChange={handleText} /></div>
        </div>

        <div className="anamnese-secao"><h2>Anamnese Física</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha"><strong>Tipo de gordura:</strong>
            {['Flácida','Compactada','Edematosa','Mista'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="tipoGordura" value={op} checked={form.tipoGordura===op} onChange={handleText} />{op}</label>))}
          </div>
          <div className="anamnese-radio-linha"><strong>Flacidez de pele:</strong>
            {['Sim','Não'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="flacidezPele" value={op} checked={form.flacidezPele===op} onChange={handleText} />{op}</label>))}
          </div>
          <div className="anamnese-radio-linha"><strong>Flacidez de músculos:</strong>
            {['Sim','Não'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="flacidezMusculos" value={op} checked={form.flacidezMusculos===op} onChange={handleText} />{op}</label>))}
          </div>
          <div className="anamnese-radio-linha"><strong>Diástase:</strong>
            {['Sim','Não'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="diastase" value={op} checked={form.diastase===op} onChange={handleText} />{op}</label>))}
          </div>
          <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}><strong>Estrias:</strong>
            {['Vermelhas - são mais recentes e têm um alto fluxo sanguíneo na área','Brancas - são estrias mais antigas, já passaram do primeiro estágio, são cicatrizes presentes na pele por mais tempo'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="estrias" value={op} checked={(form.estrias||'').includes(op)} onChange={e => { const arr = (form.estrias||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'estrias',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
          <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}><strong>Celulite:</strong>
            {['Edematosa - A mais comum, associada à retenção de líquidos e inchaço','Fibrosa - Mais firme e aderida à pele, com nódulos mais definidos','Esclerótica - A mais grave, com nódulos duros e retraídos, formando "furinhos" na pele','Flácida - Surge quando há perda ou ganho de peso de maneira drástica e rápida','Dura ou compacta - Afeta pessoas que costumam manter uma rotina de exercícios'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="celulite" value={op} checked={(form.celulite||'').includes(op)} onChange={e => { const arr = (form.celulite||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'celulite',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
          <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}><strong>Grau de celulite:</strong>
            {['Grau 1 - sem ondulações ou irregularidades','Grau 2 - ondulações e "furinhos" já são percebidos sem comprimir a pele','Grau 3 - nódulos claramente perceptíveis','Grau 4 - vários nódulos, celulite "dura"'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="radio" name="grauCelulite" value={op} checked={form.grauCelulite===op} onChange={handleText} /><span>{op}</span></label>))}
          </div>
        </div>

        <div className="anamnese-secao"><h2>Genética Corporal</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha">
            <img src="/corpos.png" alt="Tipos corporais" style={{width:'220px',margin:'0.5rem 0'}} />
          </div>
          <div className="anamnese-radio-linha">
            {['1','2','3','4'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="geneticaCorporal" value={op} checked={form.geneticaCorporal===op} onChange={handleText} />{op}</label>))}
          </div>
        </div>

        <div className="anamnese-secao"><h2>Medição de Prega</h2></div>
        <div className="anamnese-inline-group">
          {['Papada','Braço','Cintura','Abdômen','Púbis','Interno de coxas','Mama acessória','Costas','Flancos','Culote'].map(campo => (
            <div key={campo} className="anamnese-inline"><label>{campo}:</label><input type="text" name={'prega'+campo.replace(/\s/g,'')} value={form['prega'+campo.replace(/\s/g,'')]||''} onChange={handleText} /></div>
          ))}
        </div>

        <div className="anamnese-secao"><h2>Medição de Circunferência</h2></div>
        <div className="anamnese-inline-group">
          {['Braço D','Braço E','Cintura','Abdômen','Quadril','Coxas D','Coxa E'].map(campo => (
            <div key={campo} className="anamnese-inline"><label>{campo}:</label><input type="text" name={'circ'+campo.replace(/\s/g,'')} value={form['circ'+campo.replace(/\s/g,'')]||''} onChange={handleText} /></div>
          ))}
        </div>

        <div className="anamnese-secao"><h2>Avaliação Bioimpedância</h2></div>
        <div className="anamnese-grid-2">
          <div className="anamnese-pergunta"><label className="anamnese-label">Peso atual:</label><input className="anamnese-input-sm" name="pesoAtual" value={form.pesoAtual||''} onChange={handleText} /></div>
          <div className="anamnese-pergunta"><label className="anamnese-label">Metabolismo em repouso (RM):</label><input className="anamnese-input-sm" name="metabolismoRepouso" value={form.metabolismoRepouso||''} onChange={handleText} /></div>
          <div className="anamnese-pergunta"><label className="anamnese-label">Idade biológica (Body Age):</label><input className="anamnese-input-sm" name="idadeBiologica" value={form.idadeBiologica||''} onChange={handleText} /></div>
        </div>
        <div className="anamnese-subsecao"><h3>Índice de Massa Corporal (IMC) <input className="anamnese-input-inline" name="imcValor" value={form.imcValor||''} onChange={handleText} placeholder="valor" /></h3></div>
        <div className="anamnese-tabela-lado">
          <div className="anamnese-tabela-col">
            {['Menos de 18,5 - Abaixo do peso','18,5 a 25 - Normal','26 a 30 - Sobrepeso','30 ou mais - Obeso'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="imc" value={op} checked={form.imc===op} onChange={handleText} />{op}</label>))}
          </div>
        </div>
        <div className="anamnese-subsecao"><h3>Percentual de Gordura Corporal (Body Fat) <input className="anamnese-input-inline" name="gorduraCorporalValor" value={form.gorduraCorporalValor||''} onChange={handleText} placeholder="%" /></h3></div>
        <div className="anamnese-tabela-lado">
          <div className="anamnese-tabela-col"><h4>Mulheres 29 a 39 anos</h4>{['Menor que 21.0 - Baixa','21.0 a 32.9 - Normal','33.0 a 38.9 - Alta','Maior que 39.0 - Muito alta'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="gorduraCorporal" value={'29-39: '+op} checked={form.gorduraCorporal==='29-39: '+op} onChange={handleText} />{op}</label>))}</div>
          <div className="anamnese-tabela-col"><h4>Mulheres 40 a 59 anos</h4>{['Menor que 23.0 - Baixa','23.0 a 33.9 - Normal','34.0 a 39.9 - Alta','Maior que 40.0 - Muito alta'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="gorduraCorporal" value={'40-59: '+op} checked={form.gorduraCorporal==='40-59: '+op} onChange={handleText} />{op}</label>))}</div>
          <div className="anamnese-tabela-col"><h4>Mulheres 60 a 79 anos</h4>{['Menor que 24.0 - Baixa','24.0 a 35.9 - Normal','36.0 a 41.9 - Alta','Maior que 42.0 - Muito alta'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="gorduraCorporal" value={'60-79: '+op} checked={form.gorduraCorporal==='60-79: '+op} onChange={handleText} />{op}</label>))}</div>
        </div>
        <div className="anamnese-subsecao"><h3>Percentual de Músculos Esquelético (Muscle) <input className="anamnese-input-inline" name="musculoEsqueleticoValor" value={form.musculoEsqueleticoValor||''} onChange={handleText} placeholder="%" /></h3></div>
        <div className="anamnese-tabela-lado">
          <div className="anamnese-tabela-col"><h4>Mulheres 18 a 39 anos</h4>{['Menor que 24.3 - Baixa','24.3 a 30.3 - Normal','30.4 a 35.3 - Alta','Maior que 35.4 - Muito alta'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="musculoEsqueletico" value={'18-39: '+op} checked={form.musculoEsqueletico==='18-39: '+op} onChange={handleText} />{op}</label>))}</div>
          <div className="anamnese-tabela-col"><h4>Mulheres 40 a 59 anos</h4>{['Menor que 24.1 - Baixa','24.1 a 30.1 - Normal','30.2 a 35.1 - Alta','Maior que 35.2 - Muito alta'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="musculoEsqueletico" value={'40-59: '+op} checked={form.musculoEsqueletico==='40-59: '+op} onChange={handleText} />{op}</label>))}</div>
          <div className="anamnese-tabela-col"><h4>Mulheres 60 a 80 anos</h4>{['Menor que 23.9 - Baixa','23.9 a 29.9 - Normal','30.0 a 34.9 - Alta','Maior que 35.0 - Muito alta'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="musculoEsqueletico" value={'60-80: '+op} checked={form.musculoEsqueletico==='60-80: '+op} onChange={handleText} />{op}</label>))}</div>
        </div>
        <div className="anamnese-subsecao"><h3>Gordura Visceral (Visceral Fat) <input className="anamnese-input-inline" name="gorduraVisceralValor" value={form.gorduraVisceralValor||''} onChange={handleText} placeholder="%" /></h3></div>
        <div className="anamnese-tabela-lado">
          <div className="anamnese-tabela-col">
            {['Menor ou igual a 9 - Normal','Entre 10 e 14 - Nível alto','Maior ou igual a 15 - Nível muito alto'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="gorduraVisceral" value={op} checked={form.gorduraVisceral===op} onChange={handleText} />{op}</label>))}
          </div>
        </div>
        {historicoBio.length > 1 && (
          <div className="anamnese-secao">
            <h2>📈 Evolução Bioimpedância</h2>
            <div className="graficos-grid">
              {[{key:'pesoAtual',label:'Peso (kg)',cor:'#8b5cf6'},{key:'imcValor',label:'IMC',cor:'#c084cf'},{key:'gorduraCorporalValor',label:'Gordura Corporal %',cor:'#e65100'},{key:'musculoEsqueleticoValor',label:'Músculo Esquelético %',cor:'#28a745'},{key:'gorduraVisceralValor',label:'Gordura Visceral %',cor:'#d32f2f'},{key:'metabolismoRepouso',label:'Metabolismo Repouso',cor:'#1a73e8'},{key:'idadeBiologica',label:'Idade Biológica',cor:'#555'}].map(g => {
                const dados = historicoBio.filter(h => h[g.key]).map((h,i) => ({seq: i+1, data: h.data ? h.data.split('-').reverse().join('/') : (i+1)+'', valor: parseFloat(h[g.key])||0, label: (h.data ? h.data.split('-').reverse().join('/') : '') + ' #' + (i+1)}));
                if (dados.length < 2) return null;
                return (
                  <div key={g.key} className="grafico-mini">
                    <h4>{g.label}</h4>
                    <ResponsiveContainer width="100%" height={120}>
                      <LineChart data={dados}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
                        <XAxis dataKey="label" tick={{fontSize:7, angle:-35, textAnchor:'end'}} height={50} />
                        <YAxis tick={{fontSize:9}} width={35} />
                        <Tooltip formatter={(v) => [v, g.label]} labelFormatter={(l) => l} />
                        <Line type="monotone" dataKey="valor" stroke={g.cor} strokeWidth={2} dot={{r:3}} />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        <div className="anamnese-secao"><h2>Sugestão Diagnóstica</h2></div>
        {P("","sugestaoDiagnosticaCorporal",3)}
        <div className="anamnese-secao"><h2>Tratamento Sugerido e Orçamento</h2></div>
        {P("","tratamentoSugeridoCorporal",3)}
        <div className="anamnese-secao"><h2>Anotações Futuras</h2></div>
        {P("","anotacoesFuturasCorporal",4)}
        <div className="fotos-section-inline"><h2>📷 Imagens (antes e depois)</h2>
          <label className="btn-upload-foto">{uploading ? 'Enviando...' : '➕ Adicionar Foto'}<input type="file" accept="image/jpeg,image/png,image/webp" onChange={uploadFoto} hidden /></label>
          <div className="fotos-grid">{fotos.map(f => (<div key={f.id} className="foto-thumb-container"><img src={`${API}/fotos-anamnese/imagem/${f.id}`} alt={f.descricao} className="foto-thumb" onClick={() => setFotoAmpliada(fotoAmpliada===f.id?null:f.id)} /><input type="date" className="foto-data-input" value={f.dataFoto || (f.dataCriacao ? f.dataCriacao.slice(0,10) : '')} onChange={async (e) => { await axios.post(`${API}/fotos-anamnese/atualizar-data/${f.id}`, {dataFoto: e.target.value}); carregarFotos(); }} /><button className="foto-delete" onClick={() => deletarFoto(f.id)}>✕</button></div>))}{fotos.length===0 && <p className="sem-agendamento">Nenhuma foto adicionada</p>}</div>
        </div>
        <div className="form-actions"><button type="button" onClick={salvar}>Salvar Anamnese</button><button type="button" className="btn-voltar" onClick={() => onNavigate(voltarPara)}>{labelVoltar}</button></div>
        {msg && <div className="mensagem-sucesso" style={{marginTop:'1rem'}}>{msg}</div>}
        </>)}

        {abaAtiva === 'Capilar' && (<>
        <div className="anamnese-secao"><h2>Anamnese Clínica</h2></div>
        <div className="anamnese-inline-group">
          <div className="anamnese-inline"><label>Queixa principal:</label><input type="text" name="queixaCapilar" value={form.queixaCapilar||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Há quanto tempo vem notando esses sintomas?</label><input type="text" name="tempoSintomasCapilar" value={form.tempoSintomasCapilar||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Sofreu mudanças na estrutura do cabelo em algum momento?</label><input type="text" name="mudancasCabelo" value={form.mudancasCabelo||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Já fez ou está fazendo algum tipo de tratamento?</label><input type="text" name="tratamentoCapilar" value={form.tratamentoCapilar||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Tem algum tipo de doença crônica, faz uso de alguma medicação?</label><input type="text" name="doencaMedicacaoCapilar" value={form.doencaMedicacaoCapilar||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Passou por algum tipo de estresse nos últimos 6 meses?</label><input type="text" name="estresseCapilar" value={form.estresseCapilar||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Como é sua alimentação e ingestão de água?</label><input type="text" name="alimentacaoCapilar" value={form.alimentacaoCapilar||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Como é sua rotina de sono?</label><input type="text" name="sonoCapilar" value={form.sonoCapilar||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Seu intestino funciona bem?</label><input type="text" name="intestinoCapilar" value={form.intestinoCapilar||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Como é sua rotina de higienização dos cabelos?</label><input type="text" name="higienizacaoCabelos" value={form.higienizacaoCabelos||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Etilista ou tabagista?</label><input type="text" name="etilistaCapilar" value={form.etilistaCapilar||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Se considera ansiosa?</label><input type="text" name="ansiosaCapilar" value={form.ansiosaCapilar||''} onChange={handleText} /></div>
        </div>

        <div className="anamnese-secao"><h2>Anamnese física e tricoscópica</h2></div>
        <div className="anamnese-inline-group">
          <div className="anamnese-inline"><label>Tipo de cabelo:</label><input type="text" name="tipoCabelo" value={form.tipoCabelo||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Condições do couro cabeludo?</label><input type="text" name="condicoesCouroCabeludo" value={form.condicoesCouroCabeludo||''} onChange={handleText} /></div>
        </div>
        <div className="anamnese-radio-group">
          <div style={{display:'flex',gap:'1.5rem',alignItems:'flex-start',flexWrap:'wrap',justifyContent:'space-between'}}>
            <div>
              <strong>Divisão do couro cabeludo:</strong>
              {['Região Parietal – Topo da cabeça','Região Ociptal – Nuca','Região Lateral e Temporal – Laterais','Região do arco'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="divisaoCouroCabeludo" value={op} checked={(form.divisaoCouroCabeludo||'').includes(op)} onChange={e => { const arr = (form.divisaoCouroCabeludo||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'divisaoCouroCabeludo',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
            </div>
            <img src="/cabelos.jpeg" alt="Escala de calvície" style={{width:'200px',borderRadius:'8px'}} />
          </div>
        </div>

        <div className="anamnese-secao"><h2>Sugestão Diagnóstica</h2></div>
        {P("","sugestaoDiagnosticaCapilar",3)}
        <div className="anamnese-secao"><h2>Tratamento Sugerido e Orçamento</h2></div>
        {P("","tratamentoSugeridoCapilar",3)}
        <div className="anamnese-secao"><h2>Anotações Futuras</h2></div>
        {P("","anotacoesFuturasCapilar",4)}
        <div className="fotos-section-inline"><h2>📷 Imagens (antes e depois)</h2>
          <label className="btn-upload-foto">{uploading ? 'Enviando...' : '➕ Adicionar Foto'}<input type="file" accept="image/jpeg,image/png,image/webp" onChange={uploadFoto} hidden /></label>
          <div className="fotos-grid">{fotos.map(f => (<div key={f.id} className="foto-thumb-container"><img src={`${API}/fotos-anamnese/imagem/${f.id}`} alt={f.descricao} className="foto-thumb" onClick={() => setFotoAmpliada(fotoAmpliada===f.id?null:f.id)} /><input type="date" className="foto-data-input" value={f.dataFoto || (f.dataCriacao ? f.dataCriacao.slice(0,10) : '')} onChange={async (e) => { await axios.post(`${API}/fotos-anamnese/atualizar-data/${f.id}`, {dataFoto: e.target.value}); carregarFotos(); }} /><button className="foto-delete" onClick={() => deletarFoto(f.id)}>✕</button></div>))}{fotos.length===0 && <p className="sem-agendamento">Nenhuma foto adicionada</p>}</div>
        </div>
        <div className="form-actions"><button type="button" onClick={salvar}>Salvar Anamnese</button><button type="button" className="btn-voltar" onClick={() => onNavigate(voltarPara)}>{labelVoltar}</button></div>
        {msg && <div className="mensagem-sucesso" style={{marginTop:'1rem'}}>{msg}</div>}
        </>)}
        {abaAtiva === 'Podal' && (<>
        <div className="anamnese-header"><h2>Anamnese Clínica</h2><span className="anamnese-data">{dataAvaliacao}</span></div>
        <div className="anamnese-inline-group">
          <div className="anamnese-inline"><label>Queixa principal:</label><input type="text" name="queixaPodal" value={form.queixaPodal||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Já fez algum tratamento antes?</label><input type="text" name="tratamentoAnteriorPodal" value={form.tratamentoAnteriorPodal||''} onChange={handleText} /></div>
        </div>

        <div className="anamnese-secao"><h2>Avaliação dos Pés - Pele</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}>
            {['Normal','Ressecada','Descamativa','Hiperidrose (suor excessivo)','Bromidrose (mau odor)','Fissuras','Calosidades','Hiperqueratose'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="pelePodal" value={op} checked={(form.pelePodal||'').includes(op)} onChange={e => { const arr = (form.pelePodal||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'pelePodal',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
          <div className="anamnese-inline"><label>Observações:</label><input type="text" name="pelePodalObs" value={form.pelePodalObs||''} onChange={handleText} /></div>
        </div>

        <div className="anamnese-secao"><h2>Avaliação dos Pés - Unhas</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}>
            {['Saudáveis','Onicomicose','Onicocriptose (unha encravada)','Onicólise','Onicogrifose','Unha traumática','Alteração de coloração','Espessamento'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="unhasPodal" value={op} checked={(form.unhasPodal||'').includes(op)} onChange={e => { const arr = (form.unhasPodal||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'unhasPodal',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
          <div className="anamnese-inline"><label>Observações:</label><input type="text" name="unhasPodalObs" value={form.unhasPodalObs||''} onChange={handleText} /></div>
        </div>

        <div className="anamnese-secao"><h2>Alterações Encontradas</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}>
            {['Calo','Heloma duro','Heloma mole','Verruga plantar','Micose interdigital','Pé diabético','Rachaduras','Edema','Outros'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="alteracoesPodal" value={op} checked={(form.alteracoesPodal||'').includes(op)} onChange={e => { const arr = (form.alteracoesPodal||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'alteracoesPodal',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
        </div>

        <div className="anamnese-secao"><h2>Avaliação Circulatória</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}><strong>Sensação de:</strong>
            {['Dormência','Formigamento','Queimação','Frio excessivo','Dor ao caminhar','Inchaço'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="circulatoriaPodal" value={op} checked={(form.circulatoriaPodal||'').includes(op)} onChange={e => { const arr = (form.circulatoriaPodal||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'circulatoriaPodal',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
          <div className="anamnese-inline"><label>Observações:</label><input type="text" name="circulatoriaPodalObs" value={form.circulatoriaPodalObs||''} onChange={handleText} /></div>
        </div>

        <div className="anamnese-secao"><h2>Calçados</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}><strong>Tipo de calçado mais utilizado:</strong>
            {['Fechado','Aberto','Salto alto','Tênis','Bota','Sapato de segurança','Outros'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="calcadosPodal" value={op} checked={(form.calcadosPodal||'').includes(op)} onChange={e => { const arr = (form.calcadosPodal||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'calcadosPodal',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
        </div>

        <div className="anamnese-secao"><h2>Plano de Tratamento</h2></div>
        <div className="anamnese-inline-group">
          <div className="anamnese-inline"><label>Procedimento realizado:</label><input type="text" name="procedimentoPodal" value={form.procedimentoPodal||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Orientações fornecidas:</label><input type="text" name="orientacoesPodal" value={form.orientacoesPodal||''} onChange={handleText} /></div>
          <div className="anamnese-inline"><label>Retorno previsto:</label><input type="text" name="retornoPodal" value={form.retornoPodal||''} onChange={handleText} /></div>
        </div>

        <div className="anamnese-secao"><h2>Sugestão Diagnóstica</h2></div>
        {P("","sugestaoDiagnosticaPodal",3)}
        <div className="anamnese-secao"><h2>Anotações Futuras</h2></div>
        {P("","anotacoesFuturasPodal",4)}
        <div className="fotos-section-inline"><h2>📷 Imagens (antes e depois)</h2>
          <label className="btn-upload-foto">{uploading ? 'Enviando...' : '➕ Adicionar Foto'}<input type="file" accept="image/jpeg,image/png,image/webp" onChange={uploadFoto} hidden /></label>
          <div className="fotos-grid">{fotos.map(f => (<div key={f.id} className="foto-thumb-container"><img src={`${API}/fotos-anamnese/imagem/${f.id}`} alt={f.descricao} className="foto-thumb" onClick={() => setFotoAmpliada(fotoAmpliada===f.id?null:f.id)} /><input type="date" className="foto-data-input" value={f.dataFoto || (f.dataCriacao ? f.dataCriacao.slice(0,10) : '')} onChange={async (e) => { await axios.post(`${API}/fotos-anamnese/atualizar-data/${f.id}`, {dataFoto: e.target.value}); carregarFotos(); }} /><button className="foto-delete" onClick={() => deletarFoto(f.id)}>✕</button></div>))}{fotos.length===0 && <p className="sem-agendamento">Nenhuma foto adicionada</p>}</div>
        </div>
        <div className="form-actions"><button type="button" onClick={salvar}>Salvar Anamnese</button><button type="button" className="btn-voltar" onClick={() => onNavigate(voltarPara)}>{labelVoltar}</button></div>
        {msg && <div className="mensagem-sucesso" style={{marginTop:'1rem'}}>{msg}</div>}
        </>)}
        {abaAtiva === 'Massoterapia' && (<>
        <div className="anamnese-header"><h2>Anamnese - Massoterapia</h2><span className="anamnese-data">{dataAvaliacao}</span></div>

        <div className="anamnese-secao"><h2>Objetivo do Atendimento</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}><strong>Qual o principal motivo para procurar a massoterapia?</strong>
            {['Relaxamento','Alívio de dores musculares','Redução de estresse e ansiedade','Drenagem linfática','Pós-operatório','Redução de edema','Melhora da circulação','Recuperação muscular','Gestante','Outros'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="objetivoMasso" value={op} checked={(form.objetivoMasso||'').includes(op)} onChange={e => { const arr = (form.objetivoMasso||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'objetivoMasso',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
          {(form.objetivoMasso||'').includes('Outros') && <div className="anamnese-inline"><label>Especifique:</label><input type="text" name="objetivoMassoOutros" value={form.objetivoMassoOutros||''} onChange={handleText} /></div>}
          <div className="anamnese-inline"><label>Descreva sua queixa principal:</label><input type="text" name="queixaMasso" value={form.queixaMasso||''} onChange={handleText} /></div>
        </div>

        <div className="anamnese-secao"><h2>Histórico de Saúde</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha"><strong>Possui alguma doença diagnosticada?</strong>
            {['Não','Sim'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="doencaMasso" value={op} checked={form.doencaMasso===op} onChange={handleText} />{op}</label>))}
          </div>
          {form.doencaMasso==='Sim' && <div className="anamnese-inline"><label>Qual(is)?</label><input type="text" name="doencaMassoQual" value={form.doencaMassoQual||''} onChange={handleText} /></div>}
        </div>

        <div className="anamnese-secao"><h2>Medicamentos em Uso</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha"><strong>Faz uso contínuo de medicamentos?</strong>
            {['Não','Sim'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="medicamentoMasso" value={op} checked={form.medicamentoMasso===op} onChange={handleText} />{op}</label>))}
          </div>
          {form.medicamentoMasso==='Sim' && <div className="anamnese-inline"><label>Quais?</label><input type="text" name="medicamentoMassoQual" value={form.medicamentoMassoQual||''} onChange={handleText} /></div>}
        </div>

        <div className="anamnese-secao"><h2>Alergias</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha"><strong>Possui alergias?</strong>
            {['Não','Sim'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="alergiaMasso" value={op} checked={form.alergiaMasso===op} onChange={handleText} />{op}</label>))}
          </div>
          {form.alergiaMasso==='Sim' && <div className="anamnese-inline"><label>Qual(is)?</label><input type="text" name="alergiaMassoQual" value={form.alergiaMassoQual||''} onChange={handleText} /></div>}
        </div>

        <div className="anamnese-secao"><h2>Histórico Cirúrgico</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha"><strong>Já realizou alguma cirurgia?</strong>
            {['Não','Sim'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="cirurgiaMasso" value={op} checked={form.cirurgiaMasso===op} onChange={handleText} />{op}</label>))}
          </div>
          {form.cirurgiaMasso==='Sim' && <div className="anamnese-inline"><label>Qual?</label><input type="text" name="cirurgiaMassoQual" value={form.cirurgiaMassoQual||''} onChange={handleText} /></div>}
          <div className="anamnese-radio-linha"><strong>Possui próteses ou implantes?</strong>
            {['Não','Sim'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="proteseMasso" value={op} checked={form.proteseMasso===op} onChange={handleText} />{op}</label>))}
          </div>
          {form.proteseMasso==='Sim' && <div className="anamnese-inline"><label>Qual(is)?</label><input type="text" name="proteseMassoQual" value={form.proteseMassoQual||''} onChange={handleText} /></div>}
        </div>

        <div className="anamnese-secao"><h2>Avaliação da Dor</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha"><strong>Apresenta dor atualmente?</strong>
            {['Não','Sim'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="dorMasso" value={op} checked={form.dorMasso===op} onChange={handleText} />{op}</label>))}
          </div>
          {form.dorMasso==='Sim' && (<>
            <div className="anamnese-inline"><label>Local:</label><input type="text" name="dorMassoLocal" value={form.dorMassoLocal||''} onChange={handleText} /></div>
            <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}><strong>Tipo de dor:</strong>
              {['Pontada','Queimação','Pressão','Peso','Latejante','Outro'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="tipoDorMasso" value={op} checked={(form.tipoDorMasso||'').includes(op)} onChange={e => { const arr = (form.tipoDorMasso||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'tipoDorMasso',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
            </div>
            <div className="anamnese-radio-linha"><strong>Intensidade da dor (0 a 10):</strong>
              {[0,1,2,3,4,5,6,7,8,9,10].map(n => (<label key={n} className="anamnese-radio-inline"><input type="radio" name="intensidadeDorMasso" value={String(n)} checked={form.intensidadeDorMasso===String(n)} onChange={handleText} />{n}</label>))}
            </div>
            <div className="anamnese-inline"><label>A dor piora com:</label><input type="text" name="dorPioraMasso" value={form.dorPioraMasso||''} onChange={handleText} /></div>
            <div className="anamnese-inline"><label>A dor melhora com:</label><input type="text" name="dorMelhoraMasso" value={form.dorMelhoraMasso||''} onChange={handleText} /></div>
          </>)}
        </div>

        <div className="anamnese-secao"><h2>Estilo de Vida</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha"><strong>Pratica atividade física?</strong>
            {['Não','Sim'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="atividadeMasso" value={op} checked={form.atividadeMasso===op} onChange={handleText} />{op}</label>))}
          </div>
          {form.atividadeMasso==='Sim' && <div className="anamnese-inline"><label>Qual?</label><input type="text" name="atividadeMassoQual" value={form.atividadeMassoQual||''} onChange={handleText} /></div>}
          <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}><strong>Quantas horas dorme por noite?</strong>
            {['Menos de 5 horas','5 a 7 horas','7 a 9 horas','Mais de 9 horas'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="radio" name="sonoMasso" value={op} checked={form.sonoMasso===op} onChange={handleText} /><span>{op}</span></label>))}
          </div>
          <div className="anamnese-radio-linha"><strong>Nível de estresse:</strong>
            {['Baixo','Moderado','Alto'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="estresseMasso" value={op} checked={form.estresseMasso===op} onChange={handleText} />{op}</label>))}
          </div>
          <div className="anamnese-radio-linha"><strong>Ingestão de água por dia:</strong>
            {['Menos de 1 litro','1 a 2 litros','Mais de 2 litros'].map(op => (<label key={op} className="anamnese-radio-inline"><input type="radio" name="aguaMasso" value={op} checked={form.aguaMasso===op} onChange={handleText} />{op}</label>))}
          </div>
        </div>

        <div className="anamnese-secao"><h2>Avaliação Postural e Muscular</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}><strong>Tensão Muscular:</strong>
            {['Cervical','Ombros','Trapézio','Lombar','Glúteos','Membros inferiores','Generalizada'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="tensaoMasso" value={op} checked={(form.tensaoMasso||'').includes(op)} onChange={e => { const arr = (form.tensaoMasso||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'tensaoMasso',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
          <div className="anamnese-inline"><label>Observações:</label><input type="text" name="tensaoMassoObs" value={form.tensaoMassoObs||''} onChange={handleText} /></div>
          <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}><strong>Alterações Observadas:</strong>
            {['Contraturas musculares','Edema','Retenção de líquidos','Limitação de movimento','Sensibilidade aumentada','Rigidez muscular','Outros'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="alteracoesMasso" value={op} checked={(form.alteracoesMasso||'').includes(op)} onChange={e => { const arr = (form.alteracoesMasso||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'alteracoesMasso',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
        </div>

        <div className="anamnese-secao"><h2>Contraindicações</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}><strong>Possui atualmente:</strong>
            {['Febre','Infecção','Feridas abertas','Fraturas recentes','Inflamação aguda','Trombose','Gestação de risco','Hipertensão descontrolada','Nenhuma das opções'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="contraindicacoesMasso" value={op} checked={(form.contraindicacoesMasso||'').includes(op)} onChange={e => { const arr = (form.contraindicacoesMasso||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'contraindicacoesMasso',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
          <div className="anamnese-inline"><label>Observações:</label><input type="text" name="contraindicacoesMassoObs" value={form.contraindicacoesMassoObs||''} onChange={handleText} /></div>
        </div>

        <div className="anamnese-secao"><h2>Plano de Tratamento</h2></div>
        <div className="anamnese-radio-group">
          <div className="anamnese-radio-linha" style={{flexDirection:'column',alignItems:'flex-start'}}><strong>Tipo de massagem indicada:</strong>
            {['Relaxante','Aura','Drenagem Linfática','Desportiva','Liberação Miofascial','Pós-operatória','Gestacional','Reflexologia Podal','Ventosaterapia','Pedras quentes','Bambu'].map(op => (<label key={op} className="anamnese-radio-inline" style={{display:'flex',marginBottom:'0.3rem'}}><input type="checkbox" name="tipoMassagem" value={op} checked={(form.tipoMassagem||'').includes(op)} onChange={e => { const arr = (form.tipoMassagem||'').split('|').filter(Boolean); if(e.target.checked) arr.push(op); else arr.splice(arr.indexOf(op),1); handleText({target:{name:'tipoMassagem',value:arr.join('|')}}); }} /><span>{op}</span></label>))}
          </div>
          <div className="anamnese-inline"><label>Número de sessões sugeridas:</label><input type="text" name="sessoesMasso" value={form.sessoesMasso||''} onChange={handleText} /></div>
        </div>

        <div className="anamnese-secao"><h2>Evolução do Atendimento</h2></div>
        {P("","evolucaoMasso",4)}

        <div className="fotos-section-inline"><h2>📷 Imagens</h2>
          <label className="btn-upload-foto">{uploading ? 'Enviando...' : '➕ Adicionar Foto'}<input type="file" accept="image/jpeg,image/png,image/webp" onChange={uploadFoto} hidden /></label>
          <div className="fotos-grid">{fotos.map(f => (<div key={f.id} className="foto-thumb-container"><img src={`${API}/fotos-anamnese/imagem/${f.id}`} alt={f.descricao} className="foto-thumb" onClick={() => setFotoAmpliada(fotoAmpliada===f.id?null:f.id)} /><input type="date" className="foto-data-input" value={f.dataFoto || (f.dataCriacao ? f.dataCriacao.slice(0,10) : '')} onChange={async (e) => { await axios.post(`${API}/fotos-anamnese/atualizar-data/${f.id}`, {dataFoto: e.target.value}); carregarFotos(); }} /><button className="foto-delete" onClick={() => deletarFoto(f.id)}>✕</button></div>))}{fotos.length===0 && <p className="sem-agendamento">Nenhuma foto adicionada</p>}</div>
        </div>
        <div className="form-actions"><button type="button" onClick={salvar}>Salvar Anamnese</button><button type="button" className="btn-voltar" onClick={() => onNavigate(voltarPara)}>{labelVoltar}</button></div>
        {msg && <div className="mensagem-sucesso" style={{marginTop:'1rem'}}>{msg}</div>}
        </>)}

        {abaAtiva === 'Anamnese Antiga' && (<>
        <div className="anamnese-header"><h2>📁 Dados da Anamnese Anterior</h2><span className="anamnese-data">{dataAvaliacao}</span></div>
        <p style={{fontSize:'0.8rem',color:'#888',marginBottom:'1rem'}}><em>Estes campos são da versão anterior. Use para consultar ou migrar dados para as novas abas.</em></p>
        {P("Queixa","queixa")}
        {P("A quanto tempo?","quantoTempo")}
        {P("Já fez ou faz algum tratamento para resolver?","tratamentoAnterior")}
        {P("Existem casos na família?","casosFamilia")}
        {P("Rotina alimentar e hídrica?","rotinaAlimentar")}
        {P("Rotina de cuidados com (cabelo/pele/corpo)?","rotinaCuidados")}
        {P("Fumante ou etilista?","fumanteEtilista")}
        {P("Algum problema de saúde crônico, agudo ou emocional?","problemaSaude")}
        {P("Algum tipo de alergia?","alergia")}
        {P("Cirurgia ou tratamento nos últimos 6 meses?","cirurgiaRecente")}
        {P("Faz uso de algum tipo de medicação contínua?","medicacaoContinua")}
        {P("Está com exames em dia?","examesDia")}
        <div className="anamnese-secao"><h2>Avaliação Dermatoscópica</h2></div>
        {P("Achados:","achadosDermatoscopico",3)}
        <div className="anamnese-secao"><h2>Avaliação Física</h2></div>
        {P("Achados:","achadosFisico",3)}
        <div className="anamnese-secao"><h2>Avaliação Bioimpedância</h2></div>
        <div className="anamnese-grid-2">
          <div className="anamnese-pergunta"><label className="anamnese-label">Peso atual:</label><input className="anamnese-input-sm" name="pesoAtual" value={form.pesoAtual||''} onChange={handleText} /></div>
          <div className="anamnese-pergunta"><label className="anamnese-label">Metabolismo em repouso (RM):</label><input className="anamnese-input-sm" name="metabolismoRepouso" value={form.metabolismoRepouso||''} onChange={handleText} /></div>
          <div className="anamnese-pergunta"><label className="anamnese-label">Idade biológica (Body Age):</label><input className="anamnese-input-sm" name="idadeBiologica" value={form.idadeBiologica||''} onChange={handleText} /></div>
        </div>
        <div className="anamnese-subsecao"><h3>IMC <input className="anamnese-input-inline" name="imcValor" value={form.imcValor||''} onChange={handleText} placeholder="valor" /></h3></div>
        <div className="anamnese-tabela-lado"><div className="anamnese-tabela-col">
          {['Menos de 18,5 - Abaixo do peso','18,5 a 25 - Normal','26 a 30 - Sobrepeso','30 ou mais - Obeso'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="imc" value={op} checked={form.imc===op} onChange={handleText} />{op}</label>))}
        </div></div>
        <div className="anamnese-subsecao"><h3>Gordura Corporal <input className="anamnese-input-inline" name="gorduraCorporalValor" value={form.gorduraCorporalValor||''} onChange={handleText} placeholder="%" /></h3></div>
        <div className="anamnese-tabela-lado">
          <div className="anamnese-tabela-col"><h4>29-39 anos</h4>{['Menor que 21.0 - Baixa','21.0 a 32.9 - Normal','33.0 a 38.9 - Alta','Maior que 39.0 - Muito alta'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="gorduraCorporal" value={'29-39: '+op} checked={form.gorduraCorporal==='29-39: '+op} onChange={handleText} />{op}</label>))}</div>
          <div className="anamnese-tabela-col"><h4>40-59 anos</h4>{['Menor que 23.0 - Baixa','23.0 a 33.9 - Normal','34.0 a 39.9 - Alta','Maior que 40.0 - Muito alta'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="gorduraCorporal" value={'40-59: '+op} checked={form.gorduraCorporal==='40-59: '+op} onChange={handleText} />{op}</label>))}</div>
          <div className="anamnese-tabela-col"><h4>60-79 anos</h4>{['Menor que 24.0 - Baixa','24.0 a 35.9 - Normal','36.0 a 41.9 - Alta','Maior que 42.0 - Muito alta'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="gorduraCorporal" value={'60-79: '+op} checked={form.gorduraCorporal==='60-79: '+op} onChange={handleText} />{op}</label>))}</div>
        </div>
        <div className="anamnese-subsecao"><h3>Músculos Esquelético <input className="anamnese-input-inline" name="musculoEsqueleticoValor" value={form.musculoEsqueleticoValor||''} onChange={handleText} placeholder="%" /></h3></div>
        <div className="anamnese-tabela-lado">
          <div className="anamnese-tabela-col"><h4>18-39 anos</h4>{['Menor que 24.3 - Baixa','24.3 a 30.3 - Normal','30.4 a 35.3 - Alta','Maior que 35.4 - Muito alta'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="musculoEsqueletico" value={'18-39: '+op} checked={form.musculoEsqueletico==='18-39: '+op} onChange={handleText} />{op}</label>))}</div>
          <div className="anamnese-tabela-col"><h4>40-59 anos</h4>{['Menor que 24.1 - Baixa','24.1 a 30.1 - Normal','30.2 a 35.1 - Alta','Maior que 35.2 - Muito alta'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="musculoEsqueletico" value={'40-59: '+op} checked={form.musculoEsqueletico==='40-59: '+op} onChange={handleText} />{op}</label>))}</div>
          <div className="anamnese-tabela-col"><h4>60-80 anos</h4>{['Menor que 23.9 - Baixa','23.9 a 29.9 - Normal','30.0 a 34.9 - Alta','Maior que 35.0 - Muito alta'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="musculoEsqueletico" value={'60-80: '+op} checked={form.musculoEsqueletico==='60-80: '+op} onChange={handleText} />{op}</label>))}</div>
        </div>
        <div className="anamnese-subsecao"><h3>Gordura Visceral <input className="anamnese-input-inline" name="gorduraVisceralValor" value={form.gorduraVisceralValor||''} onChange={handleText} placeholder="%" /></h3></div>
        <div className="anamnese-tabela-lado"><div className="anamnese-tabela-col">
          {['Menor ou igual a 9 - Normal','Entre 10 e 14 - Nível alto','Maior ou igual a 15 - Nível muito alto'].map(op => (<label key={op} className="anamnese-radio"><input type="radio" name="gorduraVisceral" value={op} checked={form.gorduraVisceral===op} onChange={handleText} />{op}</label>))}
        </div></div>
        <div className="anamnese-secao"><h2>Sugestão Diagnóstica</h2></div>
        {P("","sugestaoDiagnostica",3)}
        <div className="anamnese-secao"><h2>Tratamento Sugerido e Orçamento</h2></div>
        {P("","tratamentoSugerido",3)}
        <div className="anamnese-secao"><h2>Anotações Futuras</h2></div>
        {P("","anotacoesFuturas",4)}
        <div className="fotos-section-inline"><h2>📷 Imagens (antes e depois)</h2>
          <label className="btn-upload-foto">{uploading ? 'Enviando...' : '➕ Adicionar Foto'}<input type="file" accept="image/jpeg,image/png,image/webp" onChange={uploadFoto} hidden /></label>
          <div className="fotos-grid">{fotos.map(f => (<div key={f.id} className="foto-thumb-container"><img src={`${API}/fotos-anamnese/imagem/${f.id}`} alt={f.descricao} className="foto-thumb" onClick={() => setFotoAmpliada(fotoAmpliada===f.id?null:f.id)} /><input type="date" className="foto-data-input" value={f.dataFoto || (f.dataCriacao ? f.dataCriacao.slice(0,10) : '')} onChange={async (e) => { await axios.post(`${API}/fotos-anamnese/atualizar-data/${f.id}`, {dataFoto: e.target.value}); carregarFotos(); }} /><button className="foto-delete" onClick={() => deletarFoto(f.id)}>✕</button></div>))}{fotos.length===0 && <p className="sem-agendamento">Nenhuma foto adicionada</p>}</div>
        </div>
        <div className="form-actions"><button type="button" onClick={salvar}>Salvar</button><button type="button" className="btn-voltar" onClick={() => onNavigate(voltarPara)}>{labelVoltar}</button></div>
        {msg && <div className="mensagem-sucesso" style={{marginTop:'1rem'}}>{msg}</div>}
        </>)}

      </div>
      {fotoAmpliada && (<div className="foto-ampliada-overlay" onClick={() => setFotoAmpliada(null)}><img src={`${API}/fotos-anamnese/imagem/${fotoAmpliada}`} alt="Foto ampliada" className="foto-ampliada" /></div>)}
    </div>
  );
}

// ==================== TELA 8: TABELA DE PREÇOS ====================
const TABELA_PRECOS_INICIAL = [
  { categoria: 'Avaliação', servicos: [
    { nome: 'Facial com dermatoscopia e prescrição de homecare', valor: 100 },
    { nome: 'Capilar com tricoscopia e prescrição de homecare', valor: 100 },
    { nome: 'Corporal com bioimpedância', valor: 100 },
    { nome: 'Podal', valor: 70 },
    { nome: 'Holística', valor: 100 },
  ], obs: 'A avaliação é feita com clientes novos. O objetivo é conhecer a pessoa e suas necessidades para oferecer um tratamento mais individualizado e eficaz, cuidando da pessoa de forma integral e não apenas dos sinais estéticos apresentados. Em caso de mais de uma avaliação na mesma consulta, é dado um desconto de 30% no total. O valor da avaliação é descontado no protocolo criado e autorizado.' },
  { categoria: 'Estética Facial', servicos: [
    { nome: 'Limpeza de Pele (60 min)', valor: 150 },
    { nome: 'Hidratação facial fotônica com drenagem facial', valor: 150 },
    { nome: 'Nutrição facial fotônica com drenagem facial', valor: 150 },
    { nome: 'Peeling Químico Renovador', valor: 200 },
  ], personalizados: ['Tratamento contra acne','Tratamento para melasma, rosácea e manchas ou cicatrizes de acne','Tratamento para rugas, bigode chinês, flacidez e envelhecimento tecidual'], obs: 'O orçamento desses serviços é elaborado após avaliação. O tipo de procedimento, manipulação e quantidade de sessões são indicados conforme as necessidades de cada pessoa.' },
  { categoria: 'Estética Corporal Personalizada', servicos: [], personalizados: ['Redução de medidas (abdome, papada, interno de coxas, braços, costas...)','Redução de peso','Tratamento para manchas (axilas, virilha, interno de coxas...)','Tratamento para celulite e lipedema','Tratamento para rejuvenescimento das mãos','Tratamento para rejuvenescimento do colo','Tratamento para melhora tecidual dos glúteos'], obs: 'O orçamento desses serviços é elaborado após avaliação. O tipo de procedimento, manipulação e quantidade de sessões são indicados conforme as necessidades de cada pessoa.' },
  { categoria: 'Estética Capilar Personalizada', servicos: [], personalizados: ['Tratamento para dermatites','Tratamento para calvície (alopecia androgenética e outros tipos de alopecia)','Tratamento para queda de cabelo (difusa)','Tratamento para couro cabeludo (sensibilidade)'], obs: 'O orçamento desses serviços é elaborado após avaliação. O tipo de procedimento, manipulação e quantidade de sessões são indicados conforme as necessidades de cada pessoa.' },
  { categoria: 'Massoterapia', subcategorias: [
    { nome: 'Massagem Relaxante (60 min)', pacotes: [{qtd:'Sessão',valor:130},{qtd:'Cinco sessões',valor:600},{qtd:'Dez sessões',valor:1000}] },
    { nome: 'Massagem Aura (60 min)', pacotes: [{qtd:'Sessão',valor:150},{qtd:'Cinco sessões',valor:700},{qtd:'Dez sessões',valor:1300}] },
    { nome: 'Reflexologia Podal (40 min)', pacotes: [{qtd:'Sessão',valor:70},{qtd:'Cinco sessões',valor:300},{qtd:'Dez sessões',valor:500}] },
    { nome: 'Drenagem Linfática – Membros Superiores (60 min)', pacotes: [{qtd:'Sessão',valor:120},{qtd:'Cinco sessões',valor:500},{qtd:'Dez sessões',valor:900}] },
    { nome: 'Drenagem Linfática – Membros Inferiores (60 min)', pacotes: [{qtd:'Sessão',valor:120},{qtd:'Cinco sessões',valor:500},{qtd:'Dez sessões',valor:900}] },
  ], recursos: ['Pedras quentes','Aromaterapia','Bambu','Ventosa'], obs: 'Em caso de pós-cirúrgico, faz-se necessária avaliação.' },
  { categoria: 'Depilação', servicos: [
    { nome: 'Buço e queixo', valor: 25 },
    { nome: 'Axilas', valor: 35 },
    { nome: 'Meia perna', valor: 55 },
    { nome: 'Perna inteira', valor: 70 },
    { nome: 'Contorno de biquíni', valor: 50 },
  ], obs: 'Depilação na cera, finalizada com alta frequência.' },
  { categoria: 'Podologia', servicos: [
    { nome: 'Podologia preventiva (corte técnico das unhas, remoção de calos e calosidades, tratamento de unhas encravadas)', valor: 90 },
    { nome: 'Hidratação ozonizada dos pés com reflexologia', valor: 120 },
    { nome: 'Tratamento auxiliar de micoses ungueais e plantares', valor: null },
  ] },
  { categoria: 'Assistência e Cuidados em Saúde', servicos: [
    { nome: 'Consulta de enfermagem', valor: 120 },
    { nome: 'Aferição de pressão arterial e glicemia', valor: 20 },
    { nome: 'Administração de medicamentos injetáveis', valor: 30 },
    { nome: 'Curativos simples', valor: 30 },
    { nome: 'Curativos especiais', valor: 60 },
    { nome: 'Retirada de pontos', valor: 60 },
    { nome: 'Cuidados com feridas', valor: 80 },
    { nome: 'Atendimento domiciliar', valor: null },
  ] },
];

function TelaTabelaPrecos() {
  const [tabela, setTabela] = useState(() => {
    const salvo = localStorage.getItem('tabelaPrecos');
    return salvo ? JSON.parse(salvo) : TABELA_PRECOS_INICIAL;
  });
  const [editando, setEditando] = useState(false);
  const [msg, setMsg] = useState('');
  const [novoServico, setNovoServico] = useState({});

  const salvar = () => {
    localStorage.setItem('tabelaPrecos', JSON.stringify(tabela));
    setEditando(false);
    setMsg('Tabela salva com sucesso!');
    setTimeout(() => setMsg(''), 3000);
  };

  const atualizarValor = (catIdx, servIdx, novoValor) => {
    const nova = [...tabela];
    nova[catIdx].servicos[servIdx].valor = novoValor === '' ? null : parseFloat(novoValor);
    setTabela(nova);
  };

  const atualizarPacote = (catIdx, subIdx, pacIdx, novoValor) => {
    const nova = [...tabela];
    nova[catIdx].subcategorias[subIdx].pacotes[pacIdx].valor = novoValor === '' ? 0 : parseFloat(novoValor);
    setTabela(nova);
  };

  const adicionarServico = (catIdx) => {
    const nome = novoServico[catIdx]?.nome;
    const valor = novoServico[catIdx]?.valor;
    if (!nome || !nome.trim()) return;
    const nova = [...tabela];
    if (!nova[catIdx].servicos) nova[catIdx].servicos = [];
    nova[catIdx].servicos.push({ nome: nome.trim(), valor: valor ? parseFloat(valor) : null });
    setTabela(nova);
    setNovoServico({ ...novoServico, [catIdx]: { nome: '', valor: '' } });
  };

  const removerServico = (catIdx, servIdx) => {
    if (!window.confirm('Remover este servi\u00e7o?')) return;
    const nova = [...tabela];
    nova[catIdx].servicos.splice(servIdx, 1);
    setTabela(nova);
  };

  return (
    <div className="container">
      <h1>💲 Tabela de Preços</h1>
      {msg && <div className="mensagem-sucesso">{msg}</div>}
      <div className="tabela-precos-actions">
        {!editando ? (
          <button className="btn-editar-tabela" onClick={() => setEditando(true)}>✏️ Editar Valores</button>
        ) : (
          <button className="btn-salvar-tabela" onClick={salvar}>💾 Salvar</button>
        )}
      </div>

      {tabela.map((cat, catIdx) => (
        <div key={catIdx} className="tabela-precos-categoria">
          <h2>{cat.categoria}</h2>

          {cat.servicos && cat.servicos.length > 0 && (
            <table className="tabela-precos">
              <thead><tr><th>Serviço</th><th>Valor</th>{editando && <th></th>}</tr></thead>
              <tbody>
                {cat.servicos.map((s, servIdx) => (
                  <tr key={servIdx}>
                    <td>{s.nome}</td>
                    <td className="td-valor">
                      {editando ? (
                        <input type="number" value={s.valor ?? ''} onChange={e => atualizarValor(catIdx, servIdx, e.target.value)} min="0" step="0.01" placeholder="Personalizado" />
                      ) : (
                        s.valor !== null ? formatarValor(s.valor) : <em>Personalizado</em>
                      )}
                    </td>
                    {editando && <td><button className="btn-remover-servico" onClick={() => removerServico(catIdx, servIdx)}>✖</button></td>}
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {editando && (
            <div className="adicionar-servico">
              <input type="text" placeholder="Nome do serviço" value={novoServico[catIdx]?.nome || ''} onChange={e => setNovoServico({...novoServico, [catIdx]: {...(novoServico[catIdx]||{}), nome: e.target.value}})} />
              <input type="number" placeholder="Valor (R$)" value={novoServico[catIdx]?.valor || ''} onChange={e => setNovoServico({...novoServico, [catIdx]: {...(novoServico[catIdx]||{}), valor: e.target.value}})} min="0" step="0.01" />
              <button onClick={() => adicionarServico(catIdx)}>➕</button>
            </div>
          )}

          {cat.subcategorias && cat.subcategorias.map((sub, subIdx) => (
            <div key={subIdx} className="tabela-precos-sub">
              <h3>{sub.nome}</h3>
              <table className="tabela-precos">
                <thead><tr><th>Quantidade</th><th>Valor</th></tr></thead>
                <tbody>
                  {sub.pacotes.map((p, pacIdx) => (
                    <tr key={pacIdx}>
                      <td>{p.qtd}</td>
                      <td className="td-valor">
                        {editando ? (
                          <input type="number" value={p.valor} onChange={e => atualizarPacote(catIdx, subIdx, pacIdx, e.target.value)} min="0" step="0.01" />
                        ) : formatarValor(p.valor)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}

          {cat.recursos && (
            <p className="tabela-precos-recursos"><strong>Recursos utilizados (conforme necessidade):</strong> {cat.recursos.join(', ')}</p>
          )}

          {cat.personalizados && cat.personalizados.length > 0 && (
            <div className="tabela-precos-personalizados">
              <p><strong>Estética Personalizada:</strong></p>
              <ul>{cat.personalizados.map((p, i) => <li key={i}>{p}</li>)}</ul>
            </div>
          )}

          {cat.obs && <p className="tabela-precos-obs"><strong>Obs:</strong> {cat.obs}</p>}
        </div>
      ))}
    </div>
  );
}

// ==================== TELA 9: ANOTAÇÕES ====================
function TelaAnotacoes() {
  const [anotacoes, setAnotacoes] = useState(() => {
    const salvo = localStorage.getItem('anotacoes_' + getIdEstabelecimento());
    return salvo ? JSON.parse(salvo) : [];
  });
  const [texto, setTexto] = useState('');

  const salvar = (lista) => {
    localStorage.setItem('anotacoes_' + getIdEstabelecimento(), JSON.stringify(lista));
  };

  const adicionar = () => {
    if (!texto.trim()) return;
    const nova = [{ id: Date.now(), texto, data: new Date().toLocaleString('pt-BR') }, ...anotacoes];
    setAnotacoes(nova);
    salvar(nova);
    setTexto('');
  };

  const deletar = (id) => {
    if (!window.confirm('Excluir esta anotação?')) return;
    const nova = anotacoes.filter(a => a.id !== id);
    setAnotacoes(nova);
    salvar(nova);
  };

  return (
    <div className="container">
      <h1>🗒️ Anotações</h1>
      <div className="anotacao-form">
        <textarea value={texto} onChange={e => setTexto(e.target.value)} rows={2} placeholder="Digite sua anotação..." maxLength={500} />
        <button onClick={adicionar}>➕ Adicionar</button>
      </div>
      <div className="anotacoes-lista">
        {anotacoes.map(a => (
          <div key={a.id} className="anotacao-item">
            <p className="anotacao-texto">{a.texto}</p>
            <div className="anotacao-rodape">
              <span className="anotacao-data">{a.data}</span>
              <button onClick={() => deletar(a.id)}>🗑️</button>
            </div>
          </div>
        ))}
        {anotacoes.length === 0 && <p className="sem-agendamento">Nenhuma anotação</p>}
      </div>
    </div>
  );
}

// ==================== TELA 10: BLOCO DE NOTAS ====================
function TelaBlocoNotas() {
  const [texto, setTexto] = useState(() => {
    return localStorage.getItem('blocoNotas_' + getIdEstabelecimento()) || '';
  });
  const [msg, setMsg] = useState('');

  const salvar = () => {
    localStorage.setItem('blocoNotas_' + getIdEstabelecimento(), texto);
    setMsg('Salvo!');
    setTimeout(() => setMsg(''), 2000);
  };

  return (
    <div className="container">
      <h1>📝 Bloco de Notas</h1>
      {msg && <div className="mensagem-sucesso">{msg}</div>}
      <textarea className="bloco-notas-area" value={texto} onChange={e => setTexto(e.target.value)} maxLength={2000} placeholder="Escreva livremente aqui..." />
      <div className="bloco-notas-rodape">
        <span>{texto.length}/2000</span>
        <button onClick={salvar}>💾 Salvar</button>
      </div>
    </div>
  );
}

// ==================== PAINEL DE LEMBRETES ====================
function PainelLembretes({ atualizar }) {
  const [lembretes, setLembretes] = useState([]);

  const carregar = () => {
    const idEstab = getIdEstabelecimento();
    if (!idEstab) return;
    axios.get(`${API}/lembretes?idEstab=${idEstab}`).then(r => setLembretes(r.data));
  };

  useEffect(() => {
    carregar();
    const interval = setInterval(carregar, 300000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => { carregar(); }, [atualizar]);

  const dispensar = async (l) => {
    await axios.post(`${API}/lembretes/dispensar`, { nomeCliente: l.nomeCliente, servicoChave: l.servicoChave });
    carregar();
  };

  if (lembretes.length === 0) return null;

  return (
    <div className="painel-lembretes">
      <h3>🔔 Lembretes</h3>
      {lembretes.map((l, i) => (
        <div key={i} className="lembrete-item">
          <p><em>💆 {l.nomeCliente} — {l.servico} há {l.dias} dias</em></p>
          <button onClick={() => dispensar(l)} title="Dispensar por 30 dias">✔</button>
        </div>
      ))}
    </div>
  );
}

// ==================== TELA LOGIN ====================
function TelaLogin({ onLogin }) {
  const [modo, setModo] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('reset') ? 'resetar' : 'login';
  });
  const [form, setForm] = useState({ nome: '', email: '', senha: '', novaSenha: '', estabelecimento: '' });
  const [msg, setMsg] = useState('');
  const [erro, setErro] = useState('');
  const resetToken = new URLSearchParams(window.location.search).get('reset');

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleLogin = async e => {
    e.preventDefault();
    try {
      const r = await axios.post(`${API}/auth/login`, { email: form.email, senha: form.senha });
      localStorage.setItem('usuario', JSON.stringify(r.data));
      onLogin(r.data);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao fazer login');
    }
  };

  const handleCadastro = async e => {
    e.preventDefault();
    try {
      const r = await axios.post(`${API}/auth/cadastro`, form);
      setMsg(r.data.mensagem);
      setErro('');
      setTimeout(() => { setModo('login'); setMsg(''); }, 2000);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao cadastrar');
    }
  };

  const handleRecuperar = async e => {
    e.preventDefault();
    try {
      const r = await axios.post(`${API}/auth/recuperar-senha`, { email: form.email });
      setMsg(r.data.mensagem);
      setErro('');
    } catch (err) {
      setErro(err.response?.data?.erro || 'E-mail não encontrado');
    }
  };

  const handleResetar = async e => {
    e.preventDefault();
    try {
      const r = await axios.post(`${API}/auth/resetar-senha`, { token: resetToken, novaSenha: form.novaSenha });
      setMsg(r.data.mensagem);
      setErro('');
      window.history.replaceState({}, '', window.location.pathname);
      setTimeout(() => { setModo('login'); setMsg(''); }, 2000);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao redefinir senha');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img src="/logo.png" alt="Logo" className="login-logo" />
        <h1 className="login-titulo">FLUORITA ESPAÇO DE BELEZA</h1>

        {erro && <div className="mensagem-erro">{erro}</div>}
        {msg && <div className="mensagem-sucesso">{msg}</div>}

        {modo === 'login' && (
          <form onSubmit={handleLogin}>
            <input type="email" name="email" placeholder="E-mail" value={form.email} onChange={handleChange} required />
            <input type="password" name="senha" placeholder="Senha" value={form.senha} onChange={handleChange} required />
            <button type="submit">Entrar</button>
            <p className="login-link" onClick={() => { setModo('recuperar'); setErro(''); setMsg(''); }}>Esqueci minha senha</p>
            <p className="login-link">Ainda não tem conta? <span onClick={() => { setModo('cadastro'); setErro(''); setMsg(''); }}>Cadastre-se</span></p>
          </form>
        )}

        {modo === 'cadastro' && (
          <form onSubmit={handleCadastro}>
            <input type="text" name="nome" placeholder="Nome" value={form.nome} onChange={handleChange} required />
            <input type="email" name="email" placeholder="E-mail" value={form.email} onChange={handleChange} required />
            <input type="password" name="senha" placeholder="Senha" value={form.senha} onChange={handleChange} required />
            <input type="text" name="estabelecimento" placeholder="Nome do Estabelecimento" value={form.estabelecimento} onChange={handleChange} required />
            <button type="submit">Cadastrar</button>
            <p className="login-link" onClick={() => { setModo('login'); setErro(''); setMsg(''); }}>⬅️ Voltar ao login</p>
          </form>
        )}

        {modo === 'recuperar' && (
          <form onSubmit={handleRecuperar}>
            <input type="email" name="email" placeholder="Digite seu e-mail" value={form.email} onChange={handleChange} required />
            <button type="submit">Enviar e-mail de recuperação</button>
            <p className="login-link" onClick={() => { setModo('login'); setErro(''); setMsg(''); }}>⬅️ Voltar ao login</p>
          </form>
        )}

        {modo === 'resetar' && (
          <form onSubmit={handleResetar}>
            <p style={{fontSize:'0.9rem',color:'#555',marginBottom:'0.5rem'}}>Digite sua nova senha:</p>
            <input type="password" name="novaSenha" placeholder="Nova senha" value={form.novaSenha} onChange={handleChange} required />
            <button type="submit">Redefinir senha</button>
          </form>
        )}
      </div>
    </div>
  );
}

// ==================== APP ====================
export default function App() {
  const [usuario, setUsuario] = useState(() => {
    const salvo = localStorage.getItem('usuario');
    return salvo ? JSON.parse(salvo) : null;
  });
  const [tela, setTela] = useState('semana');
  const [menuAberto, setMenuAberto] = useState(false);
  const [lembreteTick, setLembreteTick] = useState(0);
  const navegarE = (t) => { setTela(t); setLembreteTick(n => n + 1); window.scrollTo(0,0); };

  const logout = () => {
    localStorage.removeItem('usuario');
    setUsuario(null);
  };

  if (!usuario) return <TelaLogin onLogin={setUsuario} />;

  let conteudo;
  if (tela === 'relatorio') conteudo = <TelaRelatorio onNavigate={navegarE} />;
  else if (tela === 'saida') conteudo = <TelaSaida onNavigate={navegarE} />;
  else if (tela === 'semana') conteudo = <TelaSemana onNavigate={navegarE} />;
  else if (tela === 'historico') conteudo = <TelaHistorico onNavigate={navegarE} />;
  else if (tela === 'clientes') conteudo = <TelaClientes onNavigate={navegarE} />;
  else if (tela === 'tabela-precos') conteudo = <TelaTabelaPrecos />;
  else if (tela === 'anotacoes') conteudo = <TelaAnotacoes />;
  else if (tela === 'bloco-notas') conteudo = <TelaBlocoNotas />;
  else if (tela.startsWith('anamnese-')) {
    const parts = tela.split('-');
    const idCli = parts[1];
    const origem = parts[2] || 'clientes';
    conteudo = <TelaAnamnese idCliente={idCli} origem={origem} onNavigate={navegarE} />;
  }
  else conteudo = <TelaHome onNavigate={navegarE} />;

  return (
    <>
      <button className="menu-hamburger" onClick={() => setMenuAberto(true)}>☰</button>
      <Sidebar aberto={menuAberto} onNavigate={navegarE} onFechar={() => setMenuAberto(false)} onLogout={logout} />
      {conteudo}
      {tela !== 'home' && <button className="btn-flutuante" onClick={() => navegarE('home')}>📝</button>}
      <PainelLembretes atualizar={lembreteTick} />
      <footer className="app-versao">fv1.0.9 | bv1.0.5</footer>
    </>
  );
}
